(function () {
  const STORAGE_PREFIX = 'lbec-token-customizer:';
  const FONT_OPTIONS = [
    'Roman Serif', 'Modern Sans', 'Bold Block', 'Script Accent', 'Classic Serif', 'Book Serif',
    'Elegant Serif', 'Old Style Serif', 'Slab Serif', 'Editorial Serif', 'Trajan Style',
    'Copperplate Style', 'Formal Roman', 'Caslon Style', 'Baskerville Style', 'Garamond Style',
    'Didot Style', 'Bodoni Style', 'Georgia', 'Times New Roman', 'Palatino', 'Cambria',
    'Constantia', 'Book Antiqua', 'Merriweather', 'Libre Baskerville', 'Playfair Display',
    'Cormorant Garamond', 'Crimson Text', 'Lora', 'Spectral', 'Source Serif', 'Noto Serif',
    'Clean Sans', 'Geometric Sans', 'Rounded Sans', 'Humanist Sans', 'Condensed Sans',
    'Wide Sans', 'Narrow Sans', 'Arial', 'Helvetica', 'Verdana', 'Tahoma', 'Trebuchet MS',
    'Gill Sans', 'Avenir Style', 'Futura Style', 'Montserrat', 'Poppins', 'Raleway',
    'Nunito', 'Inter', 'Roboto', 'Open Sans', 'Lato', 'Source Sans', 'Work Sans',
    'Quattrocento Sans', 'Oswald', 'Barlow', 'Karla', 'Josefin Sans', 'League Spartan',
    'Cinzel', 'Cinzel Decorative', 'Uncial Style', 'Blackletter', 'Old English Style',
    'Gothic Serif', 'Western Slab', 'Stencil', 'Varsity', 'Typewriter', 'Courier New',
    'Consolas', 'Monaco', 'Lucida Console', 'Hand Lettered', 'Casual Script', 'Brush Script',
    'Formal Script', 'Wedding Script', 'Monoline Script', 'Sign Painter', 'Pacifico Style',
    'Dancing Script Style', 'Great Vibes Style', 'Allura Style', 'Sacramento Style',
    'Cursive Accent', 'Marker', 'Chalk', 'Comic Sans MS', 'Kids Print', 'Blueprint',
    'Technical', 'Engraver Block', 'Engraver Serif', 'Engraver Script', 'Farmhouse',
    'Rustic Serif', 'Vintage Label', 'Art Deco', 'Minimal Caps', 'Small Caps',
    'Soft Rounded', 'Bold Rounded', 'Industrial', 'Athletic Block', 'Military Stencil',
    'Modern Mono', 'Thin Sans', 'Light Sans', 'Heavy Sans', 'Display Serif', 'Display Sans',
  ];
  const FONT_STACKS = {
    'Roman Serif': '"Cormorant Garamond", "Times New Roman", serif',
    'Modern Sans': '"Quattrocento Sans", Arial, sans-serif',
    'Bold Block': '"Oswald", "Arial Narrow", sans-serif',
    'Script Accent': '"Brush Script MT", "Segoe Script", cursive',
    'Classic Serif': 'Georgia, "Times New Roman", serif',
    'Book Serif': 'Palatino, "Book Antiqua", Georgia, serif',
    'Elegant Serif': '"Bodoni 72", Didot, "Times New Roman", serif',
    'Old Style Serif': 'Garamond, Georgia, serif',
    'Slab Serif': 'Rockwell, "Courier New", serif',
    'Editorial Serif': 'Baskerville, Georgia, serif',
    'Trajan Style': 'Cinzel, "Times New Roman", serif',
    'Copperplate Style': 'Copperplate, "Copperplate Gothic Light", serif',
    'Formal Roman': 'Cinzel, Georgia, serif',
    'Clean Sans': 'Arial, Helvetica, sans-serif',
    'Geometric Sans': 'Montserrat, Futura, Arial, sans-serif',
    'Rounded Sans': 'Nunito, "Arial Rounded MT Bold", Arial, sans-serif',
    'Humanist Sans': '"Gill Sans", "Trebuchet MS", sans-serif',
    'Condensed Sans': 'Oswald, "Arial Narrow", sans-serif',
    'Wide Sans': 'Verdana, Arial, sans-serif',
    'Narrow Sans': '"Arial Narrow", Oswald, sans-serif',
    'Typewriter': '"Courier New", Courier, monospace',
    'Hand Lettered': '"Comic Sans MS", "Segoe Print", cursive',
    'Casual Script': '"Segoe Script", "Brush Script MT", cursive',
    'Brush Script': '"Brush Script MT", "Segoe Script", cursive',
    'Formal Script': '"Great Vibes", "Segoe Script", cursive',
    'Wedding Script': '"Allura", "Segoe Script", cursive',
    'Monoline Script': '"Sacramento", "Segoe Script", cursive',
    'Sign Painter': '"SignPainter", "Brush Script MT", cursive',
    'Cursive Accent': '"Segoe Script", cursive',
    Marker: '"Marker Felt", "Comic Sans MS", cursive',
    Chalk: '"Chalkboard SE", "Comic Sans MS", cursive',
    Blueprint: '"Courier New", monospace',
    Technical: 'Consolas, Monaco, monospace',
    'Engraver Block': 'Oswald, "Arial Black", sans-serif',
    'Engraver Serif': 'Cinzel, Georgia, serif',
    'Engraver Script': '"Segoe Script", "Brush Script MT", cursive',
    Farmhouse: 'Georgia, "Times New Roman", serif',
    'Vintage Label': 'Rockwell, Georgia, serif',
    'Art Deco': 'Cinzel, "Arial Narrow", sans-serif',
    'Minimal Caps': 'Montserrat, Arial, sans-serif',
    'Small Caps': 'Georgia, "Times New Roman", serif',
    'Soft Rounded': 'Nunito, Arial, sans-serif',
    'Bold Rounded': '"Arial Rounded MT Bold", Arial, sans-serif',
    Industrial: 'Oswald, Impact, sans-serif',
    'Athletic Block': 'Impact, "Arial Black", sans-serif',
    'Military Stencil': 'Stencil, "Arial Black", sans-serif',
    'Modern Mono': 'Consolas, Monaco, monospace',
    'Thin Sans': 'Raleway, Arial, sans-serif',
    'Light Sans': 'Lato, Arial, sans-serif',
    'Heavy Sans': 'Impact, "Arial Black", sans-serif',
    'Display Serif': 'Didot, Georgia, serif',
    'Display Sans': 'Montserrat, Arial, sans-serif',
  };
  const FONT_MAP = FONT_OPTIONS.reduce((map, font) => {
    map[font] = FONT_STACKS[font] || `"${font}", Arial, sans-serif`;
    return map;
  }, {});
  const PREVIEWABLE_PATTERN = /\.(png|jpe?g|svg|webp|gif|bmp)$/i;
  const TOKEN_MIN_QUANTITY = 24;
  const TOKEN_QUANTITY_STEP = 12;
  const TOKEN_COMPONENT_PRICES = {
    base: {
      '25-99': 420,
      '100-249': 420,
      '250-499': 420,
      '500-999': 420,
      '1000+': 420,
    },
    secondSide: {
      '25-99': 180,
      '100-249': 180,
      '250-499': 180,
      '500-999': 180,
      '1000+': 180,
    },
    productionSetup: 390,
    names: 450,
    packaging: {
      individual: 480,
      gift: 960,
      giftBox: 1650,
    },
  };
  const PACKAGING_LABELS = {
    individual: 'individual bags',
    giftBox: 'gift box packaging',
  };
  const TOKEN_TIER_ORDER = ['25-99', '100-249', '250-499', '500-999', '1000+'];
  const TOKEN_TIER_PRESENTATION = {
    '25-99': { key: 'base', label: 'Base', cls: '' },
    '100-249': { key: 'premium', label: 'Premium', cls: 'tier-premium' },
    '250-499': { key: 'pro', label: 'Pro', cls: 'tier-pro' },
    '500-999': { key: 'advantage', label: 'Bulk Advantage', cls: 'tier-advantage' },
    '1000+': { key: 'wholesale', label: 'Wholesale', cls: 'tier-wholesale' },
  };

  const encodeSvg = (svg) => `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const escapeXml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  const slugify = (value) => String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'item';

  const readJSON = (key, fallback) => {
    try {
      const raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (_) {
      return fallback;
    }
  };

  const parseJSONScript = (root, selector, fallback = {}) => {
    try {
      return JSON.parse(root.querySelector(selector)?.textContent || JSON.stringify(fallback));
    } catch (_) {
      return fallback;
    }
  };

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((Number(cents) || 0) / 100);
  };

  const tokenTierForQuantity = (quantity) => {
    if (quantity >= 1000) return '1000+';
    if (quantity >= 500) return '500-999';
    if (quantity >= 250) return '250-499';
    if (quantity >= 100) return '100-249';
    return '25-99';
  };

  const nextTierCopy = (quantity, hasBack) => {
    if (quantity >= 1000) {
      return hasBack ? '50-cent front/back volume rate active.' : 'Best front-only volume rate active.';
    }
    return 'Average per-token pricing decreases smoothly as the one-time production setup is spread across the order.';
  };

  const normalizeTokenQuantity = (quantity) => {
    const parsed = Math.floor(Number(quantity));
    const safe = Math.max(TOKEN_MIN_QUANTITY, Number.isFinite(parsed) ? parsed : TOKEN_MIN_QUANTITY);
    const remainder = (safe - TOKEN_MIN_QUANTITY) % TOKEN_QUANTITY_STEP;
    return remainder === 0 ? safe : safe + TOKEN_QUANTITY_STEP - remainder;
  };

  const readCartQuantity = (form) => {
    const formQuantity = form?.querySelector('[name="quantity"]');
    const formId = form?.getAttribute('id');
    const associatedQuantity = formId
      ? document.querySelector(`[name="quantity"][form="${CSS.escape(formId)}"]`)
      : null;
    const raw = formQuantity?.value || associatedQuantity?.value || '1';
    return normalizeTokenQuantity(raw);
  };

  const writeJSON = (key, value) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (_) {
      // Local persistence is a convenience only.
    }
  };

  const readText = (key) => {
    try {
      return window.localStorage.getItem(key) || '';
    } catch (_) {
      return '';
    }
  };

  const writeText = (key, value) => {
    try {
      window.localStorage.setItem(key, String(value || ''));
    } catch (_) {
      // Best effort only.
    }
  };

  const requestJson = async (url, options = {}) => {
    const headers = Object.assign(
      { Accept: 'application/json' },
      options.body ? { 'Content-Type': 'application/json' } : {},
      options.headers || {},
    );
    const response = await fetch(url, Object.assign({}, options, {
      credentials: 'same-origin',
      headers,
    }));
    const parsed = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(parsed.detail || parsed.message || `Request failed (${response.status})`);
    }
    return parsed;
  };

  const defaultBorders = () => ([
    {
      id: 'none',
      name: 'None',
      src: encodeSvg("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'></svg>"),
      category: 'Borders',
      subcategory: '',
    },
    {
      id: 'simple-ring',
      name: 'Simple Ring',
      src: encodeSvg("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='39' fill='none' stroke='#17120b' stroke-width='1.1'/></svg>"),
      category: 'Borders',
      subcategory: '',
    },
    {
      id: 'double-ring',
      name: 'Double Ring',
      src: encodeSvg("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='39' fill='none' stroke='#17120b' stroke-width='1.1'/><circle cx='50' cy='50' r='32' fill='none' stroke='#17120b' stroke-width='0.8'/></svg>"),
      category: 'Borders',
      subcategory: '',
    },
    {
      id: 'dotted',
      name: 'Dotted',
      src: encodeSvg("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='38' pathLength='100' fill='none' stroke='#17120b' stroke-width='1.35' stroke-linecap='round' stroke-dasharray='0.01 3.99'/></svg>"),
      category: 'Borders',
      subcategory: '',
    },
    {
      id: 'dashed',
      name: 'Dashed',
      src: encodeSvg("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='38.5' fill='none' stroke='#17120b' stroke-width='1.2' stroke-dasharray='5 4'/></svg>"),
      category: 'Borders',
      subcategory: '',
    },
    {
      id: 'sunburst',
      name: 'Sunburst',
      src: encodeSvg("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='37.5' fill='none' stroke='#17120b' stroke-width='1'/><path d='M50 9v7M66.4 12.6l-2.8 6.4M80 22.5l-5 4.9M88 37.2l-6.8 1.9M88 62.8l-6.8-1.9M80 77.5l-5-4.9M66.4 87.4l-2.8-6.4M50 91v-7M33.6 87.4l2.8-6.4M20 77.5l5-4.9M12 62.8l6.8-1.9M12 37.2l6.8 1.9M20 22.5l5 4.9M33.6 12.6l2.8 6.4' stroke='#17120b' stroke-width='0.95' stroke-linecap='round'/></svg>"),
      category: 'Borders',
      subcategory: '',
    },
    {
      id: 'wavy',
      name: 'Wavy',
      src: encodeSvg("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><path d='M50 10c4.8 5.2 10.6 5.7 16 1.5 2.3 6.6 7.1 9.8 14.1 9.1-.7 7 2.5 11.8 9.1 14.1-4.2 5.4-3.7 11.2 1.5 16-5.2 4.8-5.7 10.6-1.5 16-6.6 2.3-9.8 7.1-9.1 14.1-7-.7-11.8 2.5-14.1 9.1-5.4-4.2-11.2-3.7-16 1.5-4.8-5.2-10.6-5.7-16-1.5-2.3-6.6-7.1-9.8-14.1-9.1.7-7-2.5-11.8-9.1-14.1 4.2-5.4 3.7-11.2-1.5-16 5.2-4.8 5.7-10.6 1.5-16 6.6-2.3 9.8-7.1 9.1-14.1 7 .7 11.8-2.5 14.1-9.1 5.4 4.2 11.2 3.7 16-1.5Z' fill='none' stroke='#17120b' stroke-width='1.05' stroke-linejoin='round'/></svg>"),
      category: 'Borders',
      subcategory: '',
    },
    {
      id: 'thick-ring',
      name: 'Thick Ring',
      src: encodeSvg("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='38' fill='none' stroke='#17120b' stroke-width='2.2'/></svg>"),
      category: 'Borders',
      subcategory: '',
    },
    {
      id: 'thick-outer-thin-inner',
      name: 'Thick Outer + Thin Inner',
      src: encodeSvg("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='39' fill='none' stroke='#17120b' stroke-width='2'/><circle cx='50' cy='50' r='32' fill='none' stroke='#17120b' stroke-width='0.7'/></svg>"),
      category: 'Borders',
      subcategory: '',
    },
    {
      id: 'thick-outer-dotted-inner',
      name: 'Thick Outer + Dotted Inner',
      src: encodeSvg("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='39' fill='none' stroke='#17120b' stroke-width='2'/><circle cx='50' cy='50' r='32' pathLength='100' fill='none' stroke='#17120b' stroke-width='1' stroke-linecap='round' stroke-dasharray='0.01 3.99'/></svg>"),
      category: 'Borders',
      subcategory: '',
    },
  ]);

  const circlePathTop = (radius) => `M 50 50 m 0 -${radius} a ${radius} ${radius} 0 1 1 0 ${radius * 2} a ${radius} ${radius} 0 1 1 0 -${radius * 2}`;
  const circlePathBottom = (radius) => `M 50 50 m 0 ${radius} a ${radius} ${radius} 0 1 0 0 -${radius * 2} a ${radius} ${radius} 0 1 0 0 ${radius * 2}`;
  const formatPlural = (count, singular, plural = `${singular}s`) => `${count} ${count === 1 ? singular : plural}`;
  const MAX_TOKEN_FREEFORM_LAYERS = 8;
  const FREEFORM_TEXT_DEFAULT_SIZE = 8;
  const FREEFORM_TEXT_MIN_SIZE = 4;
  const FREEFORM_TEXT_MAX_SIZE = 72;
  const FREEFORM_ICON_DEFAULT_SIZE = 12;
  const FREEFORM_ICON_MIN_SIZE = 4;
  const FREEFORM_ICON_MAX_SIZE = 90;
  const ARTWORK_DEFAULT_SIZE = 36;
  const ARTWORK_MIN_SIZE = 8;
  const ARTWORK_MAX_SIZE = 90;
  const FREEFORM_POSITION_SNAPS = [25, 50, 75];
  const FREEFORM_ROTATION_SNAPS = Array.from({ length: 25 }, (_, index) => -180 + (index * 15));

  const defaultDesigns = () => ([]);

  const makeTokenIcon = (id, name, markup) => ({
    id,
    name,
    markup,
    src: encodeSvg(`<svg xmlns='http://www.w3.org/2000/svg' viewBox='-50 -50 100 100'>${markup}</svg>`),
  });

  const defaultTokenIcons = () => ([
    makeTokenIcon('star', 'Star', "<path d='M0-38 9.5-11.6 37-11.6 14.5 5.8 23 32 -0 16.8 -23 32 -14.5 5.8 -37 -11.6 -9.5 -11.6Z' fill='#17120b'/>"),
    makeTokenIcon('dot', 'Dot', "<circle cx='0' cy='0' r='8' fill='#17120b'/>"),
    makeTokenIcon('arrow-left', 'Arrow Left', "<path d='M34 -4H-5l12-12-6-6-23 22 23 22 6-6-12-12H34z' fill='#17120b'/>"),
    makeTokenIcon('arrow-right', 'Arrow Right', "<path d='M-34 -4H5L-7 -16l6 -6 23 22-23 22-6-6L5 4H-34z' fill='#17120b'/>"),
    makeTokenIcon('divider', 'Divider', "<path d='M-34 0H34' stroke='#17120b' stroke-width='5' stroke-linecap='round'/><circle cx='-40' cy='0' r='4' fill='#17120b'/><circle cx='40' cy='0' r='4' fill='#17120b'/>"),
    makeTokenIcon('sprout', 'Sprout', "<path d='M0 26V-6' stroke='#17120b' stroke-width='5' stroke-linecap='round'/><path d='M0-8C0-25 15-34 27-34 25-18 17-4 0-2Z' fill='#17120b'/><path d='M0-8C0-25-15-34-27-34-25-18-17-4 0-2Z' fill='#17120b'/>"),
    makeTokenIcon('mountain', 'Mountain', "<path d='M-38 24 -18-12 -6 4 8-26 32 24Z' fill='none' stroke='#17120b' stroke-width='6' stroke-linejoin='round'/><path d='M2-16 8-26 14-16' fill='none' stroke='#17120b' stroke-width='4' stroke-linecap='round' stroke-linejoin='round'/>"),
    makeTokenIcon('sun', 'Sun', "<circle cx='0' cy='0' r='14' fill='none' stroke='#17120b' stroke-width='5'/><path d='M0-34V-24M0 24V34M-34 0H-24M24 0H34M-24-24-17-17M24-24 17-17M-24 24-17 17M24 24 17 17' stroke='#17120b' stroke-width='4' stroke-linecap='round' stroke-linejoin='round'/>"),
    makeTokenIcon('moon', 'Moon', "<path d='M10-30C-8-28-22-12-22 8c0 18 14 32 32 32 9 0 17-3 23-8-4 1-8 2-12 2-18 0-32-14-32-32 0-13 7-24 18-30Z' fill='#17120b'/>"),
    makeTokenIcon('heart', 'Heart', "<path d='M0 30-24 6C-34-4-34-19-23-27-14-34-1-31 0-20 1-31 14-34 23-27 34-19 34-4 24 6Z' fill='#17120b'/>"),
    makeTokenIcon('diamond', 'Diamond', "<path d='M0-34 30 0 0 34-30 0Z' fill='none' stroke='#17120b' stroke-width='6' stroke-linejoin='round'/>"),
    makeTokenIcon('square', 'Square', "<rect x='-24' y='-24' width='48' height='48' fill='none' stroke='#17120b' stroke-width='6' rx='2'/>"),
    makeTokenIcon('triangle', 'Triangle', "<path d='M0-32 30 24-30 24Z' fill='none' stroke='#17120b' stroke-width='6' stroke-linejoin='round'/>"),
    makeTokenIcon('hexagon', 'Hexagon', "<path d='M-22-28H22L38 0 22 28H-22L-38 0Z' fill='none' stroke='#17120b' stroke-width='5' stroke-linejoin='round'/>"),
    makeTokenIcon('shield', 'Shield', "<path d='M0-34 24-24V-4C24 18 10 30 0 34-10 30-24 18-24-4V-24Z' fill='none' stroke='#17120b' stroke-width='5' stroke-linejoin='round'/>"),
    makeTokenIcon('flag', 'Flag', "<path d='M-18 34V-32' stroke='#17120b' stroke-width='5' stroke-linecap='round'/><path d='M-15-24H20L10-8 20 8H-15Z' fill='none' stroke='#17120b' stroke-width='5' stroke-linejoin='round'/>"),
    makeTokenIcon('check', 'Check', "<path d='M-28 2-8 22 30-20' fill='none' stroke='#17120b' stroke-width='7' stroke-linecap='round' stroke-linejoin='round'/>"),
    makeTokenIcon('x-mark', 'X Mark', "<path d='M-24-24 24 24M24-24-24 24' fill='none' stroke='#17120b' stroke-width='7' stroke-linecap='round'/>"),
    makeTokenIcon('plus', 'Plus', "<path d='M0-30V30M-30 0H30' fill='none' stroke='#17120b' stroke-width='7' stroke-linecap='round'/>"),
    makeTokenIcon('minus', 'Minus', "<path d='M-30 0H30' fill='none' stroke='#17120b' stroke-width='7' stroke-linecap='round'/>"),
    makeTokenIcon('crosshair', 'Crosshair', "<circle cx='0' cy='0' r='22' fill='none' stroke='#17120b' stroke-width='4'/><path d='M0-36V-16M0 16V36M-36 0H-16M16 0H36' fill='none' stroke='#17120b' stroke-width='4' stroke-linecap='round'/>"),
    makeTokenIcon('laurel', 'Laurel', "<path d='M-10 24C-28 18-38 2-36-18c8 2 15 8 20 17M10 24C28 18 38 2 36-18c-8 2-15 8-20 17M-4 10c-8-6-12-15-12-27M4 10c8-6 12-15 12-27' fill='none' stroke='#17120b' stroke-width='4' stroke-linecap='round' stroke-linejoin='round'/>"),
    makeTokenIcon('leaf', 'Leaf', "<path d='M-4 30C-10 6 4-22 30-30 28-4 12 18-4 30Z' fill='none' stroke='#17120b' stroke-width='5' stroke-linejoin='round'/><path d='M-6 30C-2 16 10 2 24-12' fill='none' stroke='#17120b' stroke-width='4' stroke-linecap='round'/>"),
    makeTokenIcon('tree', 'Tree', "<path d='M0-34 22-6 10-6 26 16 8 16 8 32H-8V16H-26L-10-6H-22Z' fill='#17120b'/>"),
    makeTokenIcon('paw', 'Paw', "<circle cx='-16' cy='-12' r='7' fill='#17120b'/><circle cx='16' cy='-12' r='7' fill='#17120b'/><circle cx='-4' cy='-24' r='7' fill='#17120b'/><circle cx='10' cy='-26' r='7' fill='#17120b'/><path d='M0 28C-18 28-24 18-24 8c0-8 6-14 14-14 5 0 8 2 10 5 2-3 5-5 10-5 8 0 14 6 14 14 0 10-6 20-24 20Z' fill='#17120b'/>"),
    makeTokenIcon('fish', 'Fish', "<path d='M-34 0c12-14 28-22 48-18-3 6-3 12 0 18-20 4-36-4-48-18Zm48 18 16 12V18l10-18-10-18v12L14-18' fill='none' stroke='#17120b' stroke-width='5' stroke-linejoin='round'/><circle cx='-10' cy='-4' r='3' fill='#17120b'/>"),
    makeTokenIcon('anchor', 'Anchor', "<path d='M0-30v34M-20 2H20M0-34a6 6 0 1 1 0 12 6 6 0 0 1 0-12Zm-26 16c0 20 12 34 26 34S26 18 26-2M-26-2c-4 8-10 12-18 12M26-2c4 8 10 12 18 12' fill='none' stroke='#17120b' stroke-width='5' stroke-linecap='round' stroke-linejoin='round'/>"),
    makeTokenIcon('wave', 'Wave', "<path d='M-38-8c8 0 8 10 16 10s8-10 16-10 8 10 16 10 8-10 16-10 8 10 16 10M-38 10c8 0 8 10 16 10s8-10 16-10 8 10 16 10 8-10 16-10 8 10 16 10' fill='none' stroke='#17120b' stroke-width='4' stroke-linecap='round'/>"),
    makeTokenIcon('snowflake', 'Snowflake', "<path d='M0-34V34M-29-17 29 17M-29 17 29-17' fill='none' stroke='#17120b' stroke-width='4' stroke-linecap='round'/><path d='M0-34-5-26M0-34 5-26M0 34-5 26M0 34 5 26M-29-17-20-15M-29-17-24-10M29 17 20 15M29 17 24 10M-29 17-20 15M-29 17-24 10M29-17 20-15M29-17 24-10' fill='none' stroke='#17120b' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/>"),
    makeTokenIcon('flame', 'Flame', "<path d='M4-34C10-18-8-12-8 2c0 8 6 14 14 14 10 0 18-8 18-18 0-14-10-18-8-34 12 8 22 24 22 40 0 20-16 36-36 36S-34 24-34 6c0-16 10-28 18-36 0 14 12 18 12 30 0 6 4 12 8 16C6 10 10 2 10-6c0-10-4-18-6-28Z' fill='#17120b'/>"),
    makeTokenIcon('bolt', 'Bolt', "<path d='M8-34-18 4H0l-8 30L18-4H0Z' fill='#17120b'/>"),
    makeTokenIcon('crown', 'Crown', "<path d='M-34 24-26-18-8 0 0-24 8 0 26-18 34 24Z' fill='none' stroke='#17120b' stroke-width='5' stroke-linejoin='round'/><path d='M-34 24H34' stroke='#17120b' stroke-width='5' stroke-linecap='round'/>"),
    makeTokenIcon('ribbon', 'Ribbon', "<circle cx='0' cy='-10' r='16' fill='none' stroke='#17120b' stroke-width='5'/><path d='M-10 4-16 34 0 22 16 34 10 4' fill='none' stroke='#17120b' stroke-width='5' stroke-linejoin='round'/>"),
    makeTokenIcon('rosette', 'Rosette', "<path d='M0-34 9-20 26-26 20-9 34 0 20 9 26 26 9 20 0 34-9 20-26 26-20 9-34 0-20-9-26-26-9-20Z' fill='none' stroke='#17120b' stroke-width='4' stroke-linejoin='round'/><circle cx='0' cy='0' r='10' fill='none' stroke='#17120b' stroke-width='4'/>"),
    makeTokenIcon('star-4', 'Star 4 Point', "<path d='M0-34 9-9 34 0 9 9 0 34-9 9-34 0-9-9Z' fill='#17120b'/>"),
    makeTokenIcon('star-8', 'Star 8 Point', "<path d='M0-36 8-10 26-26 10-8 36 0 10 8 26 26 8 10 0 36-8 10-26 26-10 8-36 0-10-8-26-26-8-10Z' fill='#17120b'/>"),
    makeTokenIcon('ornament', 'Ornament', "<circle cx='0' cy='6' r='22' fill='none' stroke='#17120b' stroke-width='5'/><path d='M-6-18v-8h12v8M-10-28h20' fill='none' stroke='#17120b' stroke-width='4' stroke-linecap='round' stroke-linejoin='round'/>"),
    makeTokenIcon('wine-glass', 'Wine Glass', "<path d='M-14-30H14V-8C14 4 6 12 0 14-6 12-14 4-14-8Z' fill='none' stroke='#17120b' stroke-width='5' stroke-linejoin='round'/><path d='M0 14V30M-12 30H12' fill='none' stroke='#17120b' stroke-width='5' stroke-linecap='round'/>"),
  ]);

  const parseLibraryLines = (lines, kind) => {
    return (Array.isArray(lines) ? lines : [])
      .map((line) => String(line || '').trim())
      .filter(Boolean)
      .map((line) => {
        const parts = line.split('|').map((part) => part.trim()).filter(Boolean);
        if (parts.length < 2) return null;
        return {
          id: slugify(parts[0]),
          name: parts[0],
          src: parts[1],
          kind,
          category: kind === 'border' ? 'Borders' : (parts[2] || 'Library'),
          subcategory: parts[3] || '',
        };
      })
      .filter(Boolean);
  };

  const normalizeLibraryItem = (item, kind) => {
    if (!item || !item.name || !item.src) return null;
    return {
      id: slugify(item.id || item.name),
      name: String(item.name),
      src: String(item.src),
      kind,
      category: String(item.category || (kind === 'border' ? 'Borders' : 'Library')),
      subcategory: String(item.subcategory || ''),
    };
  };

  const normalizeLibraryAsset = (asset) => {
    const safe = asset && typeof asset === 'object' ? asset : {};
    const borders = (Array.isArray(safe.borders) ? safe.borders : [])
      .map((item) => normalizeLibraryItem(item, 'border'))
      .filter(Boolean);
    const categoryDesigns = (Array.isArray(safe.categories) ? safe.categories : [])
      .flatMap((category) => {
        const rootItems = (Array.isArray(category?.items) ? category.items : []).map((item) => ({
          ...item,
          src: item?.src || item?.preview_src,
          category: category?.name || item?.category,
        }));
        const nestedItems = (Array.isArray(category?.subcategories) ? category.subcategories : [])
          .flatMap((subcategory) => (Array.isArray(subcategory?.items) ? subcategory.items : []).map((item) => ({
            ...item,
            src: item?.src || item?.preview_src,
            category: category?.name || item?.category,
            subcategory: subcategory?.name || item?.subcategory,
          })));
        return [...rootItems, ...nestedItems];
      });
    const designs = [
      ...(Array.isArray(safe.designs) ? safe.designs : []),
      ...categoryDesigns,
    ]
      .map((item) => normalizeLibraryItem(item, 'design'))
      .filter(Boolean);
    return { borders, designs };
  };

  const loadTokenLibrary = async (root) => {
    const url = root.dataset.tokenLibraryUrl;
    if (!url) return { borders: [], designs: [] };
    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) return { borders: [], designs: [] };
      const payload = await response.json();
      return normalizeLibraryAsset(payload);
    } catch (_) {
      return { borders: [], designs: [] };
    }
  };

  const uniqueValues = (items) => [...new Set(items.filter(Boolean))];
  const makeLayerId = (prefix) => `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;

  const makeFreeformTextLayer = () => ({
    id: makeLayerId('text'),
    type: 'text',
    text: 'NEW TEXT',
    font: 'Roman Serif',
    bold: false,
    italic: false,
    underline: false,
    size: FREEFORM_TEXT_DEFAULT_SIZE,
    x: 50,
    y: 50,
    rotation: 0,
    align: 'center',
  });

  const makeFreeformIconLayer = () => ({
    id: makeLayerId('icon'),
    type: 'icon',
    iconId: 'star',
    size: FREEFORM_ICON_DEFAULT_SIZE,
    x: 50,
    y: 50,
    rotation: 0,
  });

  const normalizeFreeformLayer = (layer) => {
    if (!layer || typeof layer !== 'object') return null;
    if (layer.type === 'icon') {
      return {
        id: String(layer.id || makeLayerId('icon')),
        type: 'icon',
        iconId: String(layer.iconId || 'star'),
        size: clamp(Number(layer.size) || FREEFORM_ICON_DEFAULT_SIZE, FREEFORM_ICON_MIN_SIZE, FREEFORM_ICON_MAX_SIZE),
        x: clamp(Number(layer.x) || 50, 6, 94),
        y: clamp(Number(layer.y) || 50, 6, 94),
        rotation: clamp(Number(layer.rotation) || 0, -180, 180),
      };
    }
    return {
      id: String(layer.id || makeLayerId('text')),
      type: 'text',
      text: String(layer.text || ''),
      font: String(layer.font || 'Roman Serif'),
      bold: Boolean(layer.bold),
      italic: Boolean(layer.italic),
      underline: Boolean(layer.underline),
      size: clamp(Number(layer.size) || FREEFORM_TEXT_DEFAULT_SIZE, FREEFORM_TEXT_MIN_SIZE, FREEFORM_TEXT_MAX_SIZE),
      x: clamp(Number(layer.x) || 50, 6, 94),
      y: clamp(Number(layer.y) || 50, 6, 94),
      rotation: clamp(Number(layer.rotation) || 0, -180, 180),
      align: ['left', 'center', 'right'].includes(layer.align) ? layer.align : 'center',
    };
  };

  const makeSideState = (defaultBorderId) => ({
    borderId: defaultBorderId,
    centerText: '',
    outerTop: '',
    outerBottom: '',
    font: 'Roman Serif',
    textBold: false,
    textItalic: false,
    textUnderline: false,
    centerSize: 11,
    ringSize: 6.5,
    ringRadius: 25,
    topRingRadius: 25,
    bottomRingRadius: 25,
    artworkName: '',
    artworkUrl: '',
    artworkSource: '',
    artworkFile: null,
    artworkX: 50,
    artworkY: 50,
    artworkSize: ARTWORK_DEFAULT_SIZE,
    artworkRotation: 0,
    freeformLayers: [],
  });

  const initTokenCustomizer = async (root) => {
    if (root.dataset.lbecTokenReady === 'true') return;
    root.dataset.lbecTokenReady = 'true';

    const storageKey = `${STORAGE_PREFIX}${root.dataset.productHandle || 'token'}`;
    const browserKeyStorageKey = `${storageKey}:browser-key`;
    const toggle = root.querySelector('[data-lbec-token-toggle]');
    const panel = root.querySelector('[data-lbec-token-panel]');
    const stageImage = root.querySelector('[data-lbec-token-stage-image]');
    const stagePlaceholder = root.querySelector('[data-lbec-token-stage-placeholder]');
    const stageMedia = root.querySelector('.lbec-token-customizer__stage-media');
    const stageOverlay = root.querySelector('.lbec-token-customizer__stage-overlay');
    const freeformGroup = root.querySelector('[data-lbec-token-freeform-group]');
    const sideButtons = root.querySelectorAll('[data-lbec-token-side]');
    const borderGrid = root.querySelector('[data-lbec-token-border-grid]');
    const designGrid = root.querySelector('[data-lbec-token-design-grid]');
    const uploadInput = root.querySelector('[data-lbec-token-upload-input]');
    const clearArtButton = root.querySelector('[data-lbec-token-clear-art]');
    const centerInput = root.querySelector('[data-lbec-token-center-input]');
    const topInput = root.querySelector('[data-lbec-token-outer-top-input]');
    const bottomInput = root.querySelector('[data-lbec-token-outer-bottom-input]');
    const fontSelect = root.querySelector('[data-lbec-token-font-select]');
    const centerSizeValue = root.querySelector('[data-lbec-token-center-size-value]');
    const ringSizeValue = root.querySelector('[data-lbec-token-ring-size-value]');
    const topRingRadiusInput = root.querySelector('[data-lbec-token-top-ring-radius]');
    const bottomRingRadiusInput = root.querySelector('[data-lbec-token-bottom-ring-radius]');
    const artSizeInput = root.querySelector('[data-lbec-token-art-size]');
    const artXInput = root.querySelector('[data-lbec-token-art-x]');
    const artYInput = root.querySelector('[data-lbec-token-art-y]');
    const artRotationInput = root.querySelector('[data-lbec-token-art-rotation]');
    const notesInput = root.querySelector('[data-lbec-token-notes-input]');
    const borderImage = root.querySelector('[data-lbec-token-border-image]');
    const topPath = root.querySelector('[data-lbec-token-top-path]');
    const bottomPath = root.querySelector('[data-lbec-token-bottom-path]');
    const artImage = root.querySelector('[data-lbec-token-artwork-image]');
    const middleText = root.querySelector('[data-lbec-token-middle-text]');
    const topText = root.querySelector('[data-lbec-token-top-text]');
    const bottomText = root.querySelector('[data-lbec-token-bottom-text]');
    const topWrap = root.querySelector('[data-lbec-token-top-wrap]');
    const bottomWrap = root.querySelector('[data-lbec-token-bottom-wrap]');
    const sideFolder = root.querySelector('[data-lbec-token-side-folder]');
    const sideFolderLabel = root.querySelector('[data-lbec-token-side-folder-label]');
    const summarySide = root.querySelector('[data-lbec-token-summary-side]');
    const summaryBorder = root.querySelector('[data-lbec-token-summary-border]');
    const summaryArt = root.querySelector('[data-lbec-token-summary-art]');
    const fileName = root.querySelector('[data-lbec-token-file-name]');
    const summaryInput = root.querySelector('[data-lbec-token-summary-input]');
    const frontInput = root.querySelector('[data-lbec-token-front-input]');
    const backInput = root.querySelector('[data-lbec-token-back-input]');
    const artworkSourceInput = root.querySelector('[data-lbec-token-artwork-source-input]');
    const productForm = document.getElementById(root.dataset.productFormId || '');
    const quantityInput = productForm?.querySelector('[name="quantity"]') || (
      productForm?.getAttribute('id') ? document.querySelector(`[name="quantity"][form="${CSS.escape(productForm.getAttribute('id'))}"]`) : null
    );
    const productFormShell = productForm?.closest('.lbec-token-customizer__product-form') || productForm?.closest('product-form');
    const packagingSelect = root.querySelector('[data-lbec-token-packaging-select]');
    const namesToggle = root.querySelector('[data-lbec-token-names-toggle]');
    const namesPanel = root.querySelector('[data-lbec-token-names-panel]');
    const namesInput = root.querySelector('[data-lbec-token-names-input]');
    const proofCheckbox = root.querySelector('[data-lbec-token-proof-checkbox]');
    const addFreeformTextButton = root.querySelector('[data-lbec-token-add-freeform-text]');
    const addFreeformIconButton = root.querySelector('[data-lbec-token-add-freeform-icon]');
    const workflowButtons = [...root.querySelectorAll('[data-lbec-token-workflow-button]')];
    const workflowPanels = [...root.querySelectorAll('[data-lbec-token-workflow-panel]')];
    const textFormatButtons = [...root.querySelectorAll('[data-lbec-token-text-format]')];
    const textActionButtons = [...root.querySelectorAll('[data-lbec-token-text-action]')];
    const artActionButtons = [...root.querySelectorAll('[data-lbec-token-art-action]')];
    const freeformList = root.querySelector('[data-lbec-token-freeform-list]');
    const freeformEmpty = root.querySelector('[data-lbec-token-freeform-empty]');
    const freeformEditor = root.querySelector('[data-lbec-token-freeform-editor]');
    const estimateNodes = [...root.querySelectorAll('[data-lbec-token-estimate]')];
    const estimateDetails = [...root.querySelectorAll('[data-lbec-token-estimate-detail]')];
    const estimateSavingsNodes = [...root.querySelectorAll('[data-lbec-token-estimate-savings]')];
    const estimateTierTexts = [...root.querySelectorAll('[data-lbec-token-tier-text]')];
    const estimateBoxes = [...root.querySelectorAll('[data-lbec-token-pricing-summary]')];
    const libraryFilters = root.querySelector('[data-lbec-token-library-filters]');
    const categorySelect = root.querySelector('[data-lbec-token-category-select]');
    const subcategoryWrap = root.querySelector('[data-lbec-token-subcategory-wrap]');
    const subcategorySelect = root.querySelector('[data-lbec-token-subcategory-select]');

    const legacyConfig = parseJSONScript(root, '[data-lbec-token-libraries]', { borderLines: [], designLines: [] });
    const pricingComponents = parseJSONScript(root, '[data-lbec-token-pricing-components]', {});
    const componentPriceCents = (variantId, fallback) => {
      const livePrice = Number(pricingComponents.variantPrices?.[String(variantId)]);
      return Number.isFinite(livePrice) ? livePrice : fallback;
    };

    const assetLibrary = await loadTokenLibrary(root);
    const borders = defaultBorders();
    const tokenIcons = defaultTokenIcons();
    const designs = [
      ...assetLibrary.designs,
      ...parseLibraryLines(legacyConfig.designLines, 'design'),
      ...(!assetLibrary.designs.length && !(legacyConfig.designLines || []).length ? defaultDesigns() : []),
    ];

    const requestedDefaultBorderId = slugify(root.dataset.tokenDefaultBorder || borders[0]?.id || 'none');
    const defaultBorderId = borders.some((border) => border.id === requestedDefaultBorderId)
      ? requestedDefaultBorderId
      : (borders[0]?.id || 'none');
    const persisted = readJSON(storageKey, null);
    const state = {
      activeSide: 'front',
      selectedLayerId: persisted?.selectedLayerId || '',
      notes: persisted?.notes || '',
      libraryCategory: persisted?.libraryCategory || '',
      librarySubcategory: persisted?.librarySubcategory || '',
      workflowMode: persisted?.workflowMode === 'scratch' ? 'scratch' : 'upload',
      packaging: persisted?.packaging || 'none',
      names: Boolean(persisted?.names),
      namesList: persisted?.namesList || '',
      front: Object.assign(makeSideState(defaultBorderId), persisted?.front || {}),
      back: Object.assign(makeSideState(defaultBorderId), persisted?.back || {}),
    };
    state.front.artworkFile = null;
    state.back.artworkFile = null;
    state.front.freeformLayers = (Array.isArray(state.front.freeformLayers) ? state.front.freeformLayers : [])
      .map(normalizeFreeformLayer)
      .filter(Boolean)
      .slice(0, MAX_TOKEN_FREEFORM_LAYERS);
    state.back.freeformLayers = (Array.isArray(state.back.freeformLayers) ? state.back.freeformLayers : [])
      .map(normalizeFreeformLayer)
      .filter(Boolean)
      .slice(0, MAX_TOKEN_FREEFORM_LAYERS);
    state.front.artworkX = clamp(Number(state.front.artworkX) || 50, 6, 94);
    state.front.artworkY = clamp(Number(state.front.artworkY) || 50, 6, 94);
    state.front.artworkSize = clamp(Number(state.front.artworkSize) || ARTWORK_DEFAULT_SIZE, ARTWORK_MIN_SIZE, ARTWORK_MAX_SIZE);
    state.front.artworkRotation = clamp(Number(state.front.artworkRotation) || 0, -180, 180);
    state.back.artworkX = clamp(Number(state.back.artworkX) || 50, 6, 94);
    state.back.artworkY = clamp(Number(state.back.artworkY) || 50, 6, 94);
    state.back.artworkSize = clamp(Number(state.back.artworkSize) || ARTWORK_DEFAULT_SIZE, ARTWORK_MIN_SIZE, ARTWORK_MAX_SIZE);
    state.back.artworkRotation = clamp(Number(state.back.artworkRotation) || 0, -180, 180);
    if (!borders.some((border) => border.id === state.front.borderId)) state.front.borderId = defaultBorderId;
    if (!borders.some((border) => border.id === state.back.borderId)) state.back.borderId = defaultBorderId;
    let dragState = null;

    const allCategories = uniqueValues(designs.map((design) => design.category));
    if (!state.libraryCategory && allCategories.length) {
      state.libraryCategory = allCategories[0];
    }

    const getActiveSideState = () => state[state.activeSide];
    const frontImage = root.dataset.tokenFrontImage || '';
    const backImage = root.dataset.tokenBackImage || frontImage;
    const browserKey = (() => {
      const existing = readText(browserKeyStorageKey);
      if (existing) return existing;
      const created = `browser-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      writeText(browserKeyStorageKey, created);
      return created;
    })();

    const serializableSideState = (sideState) => {
      const clone = Object.assign({}, sideState);
      delete clone.artworkFile;
      return clone;
    };

    const saveState = () => {
      writeJSON(storageKey, {
        selectedLayerId: state.selectedLayerId,
        notes: state.notes,
        libraryCategory: state.libraryCategory,
        librarySubcategory: state.librarySubcategory,
        workflowMode: state.workflowMode,
        packaging: state.packaging,
        names: state.names,
        namesList: state.namesList,
        front: serializableSideState(state.front),
        back: serializableSideState(state.back),
      });
    };

    const setPanelState = (open) => {
      if (panel) panel.hidden = !open;
      if (toggle) toggle.setAttribute('aria-expanded', String(open));
    };

    const getSideLayers = (sideState) => sideState.freeformLayers || [];

    const selectedLayer = () => getSideLayers(getActiveSideState()).find((layer) => layer.id === state.selectedLayerId) || null;

    const ensureSelectedLayer = () => {
      const activeLayers = getSideLayers(getActiveSideState());
      if (!activeLayers.length) {
        state.selectedLayerId = '';
        return null;
      }
      const active = activeLayers.find((layer) => layer.id === state.selectedLayerId);
      if (active) return active;
      state.selectedLayerId = activeLayers[0].id;
      return activeLayers[0];
    };

    const populateFontSelect = (select, selectedFont = 'Roman Serif') => {
      if (!select) return;
      if (select.dataset.lbecTokenFontsReady !== 'true') {
        select.innerHTML = FONT_OPTIONS.map((font) => `<option value="${escapeXml(font)}">${escapeXml(font)}</option>`).join('');
        select.dataset.lbecTokenFontsReady = 'true';
      }
      select.value = FONT_OPTIONS.includes(selectedFont) ? selectedFont : 'Roman Serif';
    };

    const renderWorkflow = () => {
      workflowButtons.forEach((button) => {
        const active = button.dataset.lbecTokenWorkflowButton === state.workflowMode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      workflowPanels.forEach((panelNode) => {
        panelNode.hidden = panelNode.dataset.lbecTokenWorkflowPanel !== state.workflowMode;
      });
    };

    const syncTextFormatButtons = () => {
      const side = getActiveSideState();
      textFormatButtons.forEach((button) => {
        const format = button.dataset.lbecTokenTextFormat;
        const active = (format === 'bold' && side.textBold)
          || (format === 'italic' && side.textItalic)
          || (format === 'underline' && side.textUnderline);
        button.classList.toggle('is-active', Boolean(active));
        button.setAttribute('aria-pressed', String(Boolean(active)));
      });
    };

    const getTokenIconById = (iconId) => tokenIcons.find((icon) => icon.id === iconId) || tokenIcons[0];

    const summarizeFreeformLayers = (sideState) => {
      const layers = getSideLayers(sideState);
      if (!layers.length) return '';
      const textCount = layers.filter((layer) => layer.type === 'text').length;
      const iconCount = layers.filter((layer) => layer.type === 'icon').length;
      const parts = [];
      if (textCount) parts.push(formatPlural(textCount, 'text box'));
      if (iconCount) parts.push(formatPlural(iconCount, 'icon'));
      return parts.join(', ');
    };

    const renderFreeformTextLayer = (layer, options = {}) => {
      const { interactive = true } = options;
      const lines = String(layer.text || '')
        .split(/\r?\n/)
        .map((line) => line.trimEnd())
        .filter((line, index, all) => line || all.length === 1 || index < all.length - 1);
      const anchorMap = {
        left: 'start',
        center: 'middle',
        right: 'end',
      };
      const anchor = anchorMap[layer.align] || 'middle';
      const fontFamily = escapeXml(FONT_MAP[layer.font] || FONT_MAP['Roman Serif']);
      const fontWeight = layer.bold || layer.font === 'Bold Block' ? '800' : '700';
      const fontStyle = layer.italic ? 'italic' : 'normal';
      const textDecoration = layer.underline ? 'underline' : 'none';
      const baseLineHeight = layer.size * 1.05;
      const startY = layer.y - ((Math.max(lines.length, 1) - 1) * baseLineHeight) / 2;
      const lineCount = Math.max(lines.length, 1);
      const longestLine = Math.max(...(lines.length ? lines : [' ']).map((line) => line.length), 1);
      const selectionWidth = clamp(longestLine * layer.size * 0.58, 8, 88);
      const selectionHeight = clamp(lineCount * baseLineHeight, 6, 88);
      const selectionX = anchor === 'start'
        ? layer.x
        : (anchor === 'end' ? layer.x - selectionWidth : layer.x - (selectionWidth / 2));
      const selectionY = layer.y - (selectionHeight / 2);
      const isActive = interactive && layer.id === state.selectedLayerId;
      const textLines = (lines.length ? lines : ['']).map((line, index) => `
        <tspan x="${layer.x}" y="${startY + (index * baseLineHeight)}">${escapeXml(line || ' ')}</tspan>
      `).join('');
      return `
        <g
          class="lbec-token-customizer__freeform-layer lbec-token-customizer__freeform-layer--text ${isActive ? 'is-active' : ''}"
          ${interactive ? `data-lbec-token-layer-id="${layer.id}" data-lbec-token-layer-type="text"` : ''}
        >
          ${isActive ? `<rect class="lbec-token-customizer__selection-box" x="${selectionX}" y="${selectionY}" width="${selectionWidth}" height="${selectionHeight}" rx="1.5" transform="rotate(${layer.rotation} ${layer.x} ${layer.y})"></rect>` : ''}
          <text
            transform="rotate(${layer.rotation} ${layer.x} ${layer.y})"
            x="${layer.x}"
            y="${layer.y}"
            text-anchor="${anchor}"
            font-family="${fontFamily}"
            font-size="${layer.size}"
            font-weight="${fontWeight}"
            font-style="${fontStyle}"
            text-decoration="${textDecoration}"
            letter-spacing="0.03em"
            fill="#17110b"
            dominant-baseline="middle"
          >${textLines}
          </text>
        </g>
      `;
    };

    const renderFreeformIconLayer = (layer, options = {}) => {
      const { interactive = true } = options;
      const icon = getTokenIconById(layer.iconId);
      const scale = Number(layer.size) / 100;
      const isActive = interactive && layer.id === state.selectedLayerId;
      return `
        <g
          class="lbec-token-customizer__freeform-layer lbec-token-customizer__freeform-layer--icon ${isActive ? 'is-active' : ''}"
          ${interactive ? `data-lbec-token-layer-id="${layer.id}" data-lbec-token-layer-type="icon"` : ''}
          transform="translate(${layer.x} ${layer.y}) rotate(${layer.rotation}) scale(${scale})"
        >
          ${isActive ? '<rect class="lbec-token-customizer__selection-box" x="-50" y="-50" width="100" height="100" rx="6"></rect>' : ''}
          ${icon?.markup || ''}
        </g>
      `;
    };

    const renderFreeformLayers = (sideState, options = {}) => getSideLayers(sideState)
      .map((layer) => (layer.type === 'icon'
        ? renderFreeformIconLayer(layer, options)
        : renderFreeformTextLayer(layer, options)))
      .join('');

    const renderFreeformList = () => {
      if (!freeformList || !freeformEmpty) return;
      const layers = getSideLayers(getActiveSideState());
      const activeLayer = ensureSelectedLayer();

      if (addFreeformTextButton) addFreeformTextButton.disabled = layers.length >= MAX_TOKEN_FREEFORM_LAYERS;
      if (addFreeformIconButton) addFreeformIconButton.disabled = layers.length >= MAX_TOKEN_FREEFORM_LAYERS;

      freeformList.innerHTML = layers.map((layer, index) => {
        const label = layer.type === 'icon'
          ? (getTokenIconById(layer.iconId)?.name || 'Icon')
          : (String(layer.text || 'Untitled text').split(/\r?\n/)[0].trim() || 'Untitled text');
        const detail = layer.type === 'icon'
          ? `Icon accent - ${Math.round(layer.size)}% scale`
          : `Text box - ${layer.align} - ${Math.round(layer.size)} pt`;
        return `
          <div class="lbec-token-customizer__layer-card ${activeLayer?.id === layer.id ? 'is-active' : ''}" data-lbec-token-layer-card="${layer.id}">
            <div class="lbec-token-customizer__layer-card-copy">
              <strong>${index + 1}. ${escapeXml(label)}</strong>
              <span>${escapeXml(detail)}</span>
            </div>
            <div class="lbec-token-customizer__layer-card-actions">
              <button type="button" class="lbec-token-customizer__mini-button lbec-token-customizer__select-button" data-lbec-token-select-layer="${layer.id}" aria-pressed="${String(activeLayer?.id === layer.id)}">${activeLayer?.id === layer.id ? 'Selected' : 'Select'}</button>
              <button type="button" class="lbec-token-customizer__mini-button" data-lbec-token-delete-layer="${layer.id}">Remove</button>
            </div>
          </div>
        `;
      }).join('');

      freeformEmpty.hidden = layers.length > 0;
    };

    const renderLayerPositionControls = () => `
      <div class="lbec-token-customizer__position-control">
        <span class="lbec-token-customizer__control-label">Position</span>
        <div class="lbec-token-customizer__position-pad" aria-label="Move selected element">
          <button type="button" data-lbec-token-layer-action="move-up" aria-label="Move up">↑</button>
          <button type="button" data-lbec-token-layer-action="move-left" aria-label="Move left">←</button>
          <button type="button" data-lbec-token-layer-action="center" aria-label="Center element">●</button>
          <button type="button" data-lbec-token-layer-action="move-right" aria-label="Move right">→</button>
          <button type="button" data-lbec-token-layer-action="move-down" aria-label="Move down">↓</button>
        </div>
      </div>
    `;

    const renderLayerTransformControls = (label) => `
      <div class="lbec-token-customizer__transform-control">
        <span class="lbec-token-customizer__control-label">${label}</span>
        <div class="lbec-token-customizer__control-row">
          <button type="button" class="lbec-token-customizer__mini-button" data-lbec-token-layer-action="smaller" aria-label="Decrease size">−</button>
          <button type="button" class="lbec-token-customizer__mini-button" data-lbec-token-layer-action="larger" aria-label="Increase size">+</button>
          <button type="button" class="lbec-token-customizer__mini-button" data-lbec-token-layer-action="rotate-left" aria-label="Rotate counterclockwise">↶</button>
          <button type="button" class="lbec-token-customizer__mini-button" data-lbec-token-layer-action="rotate-right" aria-label="Rotate clockwise">↷</button>
        </div>
      </div>
    `;

    const renderFreeformEditor = () => {
      if (!freeformEditor) return;
      const activeLayer = ensureSelectedLayer();
      freeformEditor.hidden = !activeLayer;

      if (!activeLayer) {
        freeformEditor.innerHTML = '';
        return;
      }

      if (activeLayer.type === 'icon') {
        freeformEditor.innerHTML = `
          <div class="lbec-token-customizer__layer-editor-head">
            <div>
              <h4>Icon settings</h4>
              <p>Drag on the preview or use the arrow buttons for precise placement.</p>
            </div>
          </div>
          <div class="lbec-token-customizer__control-grid">
            <label class="lbec-token-customizer__field">
              <span>Icon</span>
              <select class="lbec-token-customizer__input" data-lbec-token-layer-field="iconId">
                ${tokenIcons.map((icon) => `<option value="${icon.id}" ${icon.id === activeLayer.iconId ? 'selected' : ''}>${escapeXml(icon.name)}</option>`).join('')}
              </select>
            </label>
          </div>
          <div class="lbec-token-customizer__layer-adjustments">
            ${renderLayerTransformControls('Size and rotation')}
            ${renderLayerPositionControls()}
          </div>
        `;
        return;
      }

      freeformEditor.innerHTML = `
        <div class="lbec-token-customizer__layer-editor-head">
          <div>
            <h4>Text box settings</h4>
            <p>Drag on the preview or use the arrow buttons for precise placement.</p>
          </div>
        </div>
        <div class="lbec-token-customizer__control-grid">
          <label class="lbec-token-customizer__field" style="grid-column: 1 / -1;">
            <span>Text</span>
            <textarea class="lbec-token-customizer__input lbec-token-customizer__textarea" rows="3" data-lbec-token-layer-field="text">${escapeXml(activeLayer.text)}</textarea>
          </label>
          <label class="lbec-token-customizer__field">
            <span>Font</span>
            <select class="lbec-token-customizer__input" data-lbec-token-layer-field="font">
              ${FONT_OPTIONS.map((font) => `<option value="${font}" ${font === activeLayer.font ? 'selected' : ''}>${escapeXml(font)}</option>`).join('')}
            </select>
          </label>
          <label class="lbec-token-customizer__field">
            <span>Alignment</span>
            <select class="lbec-token-customizer__input" data-lbec-token-layer-field="align">
              <option value="left" ${activeLayer.align === 'left' ? 'selected' : ''}>Left</option>
              <option value="center" ${activeLayer.align === 'center' ? 'selected' : ''}>Center</option>
              <option value="right" ${activeLayer.align === 'right' ? 'selected' : ''}>Right</option>
            </select>
          </label>
        </div>
        <div class="lbec-token-customizer__format-row" aria-label="Selected text style">
          <button type="button" class="${activeLayer.bold ? 'is-active' : ''}" data-lbec-token-layer-toggle="bold" aria-pressed="${String(Boolean(activeLayer.bold))}">B</button>
          <button type="button" class="${activeLayer.italic ? 'is-active' : ''}" data-lbec-token-layer-toggle="italic" aria-pressed="${String(Boolean(activeLayer.italic))}"><em>I</em></button>
          <button type="button" class="${activeLayer.underline ? 'is-active' : ''}" data-lbec-token-layer-toggle="underline" aria-pressed="${String(Boolean(activeLayer.underline))}"><span class="lbec-token-customizer__underlined">U</span></button>
        </div>
        <div class="lbec-token-customizer__layer-adjustments">
          ${renderLayerTransformControls('Text size and rotation')}
          ${renderLayerPositionControls()}
        </div>
      `;
    };

    const renderFreeformControls = (options = {}) => {
      renderFreeformList();
      if (!options.preserveEditor) {
        renderFreeformEditor();
      }
    };

    const updateSelectedLayerField = (field, value, options = {}) => {
      const side = getActiveSideState();
      const index = getSideLayers(side).findIndex((layer) => layer.id === state.selectedLayerId);
      if (index === -1) return;
      const current = getSideLayers(side)[index];
      const next = Object.assign({}, current);
      if (['size', 'x', 'y', 'rotation'].includes(field)) {
        next[field] = snapLayerFieldValue(current, field, Number(value));
      } else {
        next[field] = value;
      }
      side.freeformLayers[index] = normalizeFreeformLayer(next);
      renderFreeformList();
      renderStage();
      renderHiddenInputs();
      renderEstimate();
      saveState();
      if (!options.preserveEditor) {
        renderFreeformEditor();
      }
    };

    const setSelectedLayerId = (layerId, options = {}) => {
      state.selectedLayerId = layerId || '';
      renderFreeformList();
      renderStage();
      saveState();
      if (!options.preserveEditor) {
        renderFreeformEditor();
      }
    };

    const updateArtworkField = (field, value) => {
      const side = getActiveSideState();
      side[field] = snapArtworkFieldValue(field, Number(value));
      renderStage();
      renderHiddenInputs();
      renderEstimate();
      saveState();
      if (field === 'artworkSize' && artSizeInput) artSizeInput.value = String(side[field]);
      if (field === 'artworkX' && artXInput) artXInput.value = String(side[field]);
      if (field === 'artworkY' && artYInput) artYInput.value = String(side[field]);
      if (field === 'artworkRotation' && artRotationInput) artRotationInput.value = String(side[field]);
    };

    const buildSideSummary = (sideName, sideState) => {
      const border = borders.find((item) => item.id === sideState.borderId)?.name || 'No border';
      const art = sideState.artworkName
        ? `${sideState.artworkName} (${sideState.artworkSource || 'custom'}) at x ${Math.round(sideState.artworkX)}, y ${Math.round(sideState.artworkY)}, size ${Math.round(sideState.artworkSize)}, rotation ${Math.round(sideState.artworkRotation)}`
        : 'No centerpiece';
      const extras = summarizeFreeformLayers(sideState);
      return `${sideName}: border ${border}; center text "${sideState.centerText || ''}"; upper ring "${sideState.outerTop || ''}"; lower ring "${sideState.outerBottom || ''}"; artwork ${art}; font ${sideState.font}${extras ? `; movable elements ${extras}` : ''}`;
    };

    const serializeSideLayout = (sideState) => JSON.stringify({
      borderId: sideState.borderId,
      centerText: sideState.centerText,
      outerTop: sideState.outerTop,
      outerBottom: sideState.outerBottom,
      font: sideState.font,
      centerSize: sideState.centerSize,
      ringSize: sideState.ringSize,
      topRingRadius: sideState.topRingRadius,
      bottomRingRadius: sideState.bottomRingRadius,
      artworkName: sideState.artworkName,
      artworkSource: sideState.artworkSource,
      artworkUrl: sideState.artworkUrl || '',
      artworkX: sideState.artworkX,
      artworkY: sideState.artworkY,
      artworkSize: sideState.artworkSize,
      artworkRotation: sideState.artworkRotation,
      freeformLayers: getSideLayers(sideState),
    });

    const sideHasDesign = (side) => Boolean(
      (side.borderId && side.borderId !== 'none')
      || (side.centerText || '').trim()
      || (side.outerTop || '').trim()
      || (side.outerBottom || '').trim()
      || side.artworkName
      || getSideLayers(side).length
    );

    const tokenOptionSummary = () => {
      const parts = [];
      if (state.packaging !== 'none') parts.push(PACKAGING_LABELS[state.packaging] || `${state.packaging} packaging`);
      if (state.names) parts.push('individual names or numbers');
      return parts.length ? parts.join(', ') : 'No add-ons';
    };

    const currentZoneFrame = () => {
      const styles = stageMedia ? window.getComputedStyle(stageMedia) : null;
      return {
        top: styles?.getPropertyValue('--lbec-token-zone-top').trim() || '22%',
        left: styles?.getPropertyValue('--lbec-token-zone-left').trim() || '18%',
        width: styles?.getPropertyValue('--lbec-token-zone-width').trim() || '64%',
        height: styles?.getPropertyValue('--lbec-token-zone-height').trim() || '56%',
      };
    };

    const currentBaseOpacity = () => {
      const styles = stageMedia ? window.getComputedStyle(stageMedia) : null;
      const raw = Number(styles?.getPropertyValue('--lbec-token-base-opacity').trim());
      return Number.isFinite(raw) ? clamp(raw, 0, 1) : 0.18;
    };

    const sizeSnapValuesForLayer = (layerType) => (
      layerType === 'icon'
        ? [FREEFORM_ICON_DEFAULT_SIZE * 0.5, FREEFORM_ICON_DEFAULT_SIZE, FREEFORM_ICON_DEFAULT_SIZE * 2]
        : [FREEFORM_TEXT_DEFAULT_SIZE * 0.5, FREEFORM_TEXT_DEFAULT_SIZE, FREEFORM_TEXT_DEFAULT_SIZE * 2]
    );
    const artworkSizeSnapValues = () => [ARTWORK_DEFAULT_SIZE * 0.5, ARTWORK_DEFAULT_SIZE, ARTWORK_DEFAULT_SIZE * 2];

    const snapWithinTolerance = (value, snapValues, tolerance) => {
      const numeric = Number(value);
      if (!Number.isFinite(numeric)) return value;
      const closest = snapValues.reduce((best, snapValue) => (
        Math.abs(snapValue - numeric) < Math.abs(best - numeric) ? snapValue : best
      ), snapValues[0]);
      return Math.abs(closest - numeric) <= tolerance ? closest : numeric;
    };

    const snapLayerFieldValue = (layer, field, value) => {
      const numeric = Number(value);
      if (!Number.isFinite(numeric)) return value;
      if (field === 'rotation') {
        return snapWithinTolerance(numeric, FREEFORM_ROTATION_SNAPS, 3);
      }
      if (field === 'x' || field === 'y') {
        return snapWithinTolerance(numeric, FREEFORM_POSITION_SNAPS, 1.5);
      }
      if (field === 'size') {
        return snapWithinTolerance(numeric, sizeSnapValuesForLayer(layer.type), 1);
      }
      return value;
    };

    const snapArtworkFieldValue = (field, value) => {
      const numeric = Number(value);
      if (!Number.isFinite(numeric)) return value;
      if (field === 'artworkRotation') {
        return snapWithinTolerance(numeric, FREEFORM_ROTATION_SNAPS, 3);
      }
      if (field === 'artworkX' || field === 'artworkY') {
        return snapWithinTolerance(numeric, FREEFORM_POSITION_SNAPS, 1.5);
      }
      if (field === 'artworkSize') {
        return snapWithinTolerance(numeric, artworkSizeSnapValues(), 1);
      }
      return value;
    };

    const pointerToStagePoint = (event) => {
      if (!stageOverlay) return { x: 50, y: 50 };
      const bounds = stageOverlay.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return { x: 50, y: 50 };
      return {
        x: clamp(((event.clientX - bounds.left) / bounds.width) * 100, 6, 94),
        y: clamp(((event.clientY - bounds.top) / bounds.height) * 100, 6, 94),
      };
    };

    const buildTokenPreviewSvg = (sideName, sideState, baseImageUrl) => {
      const zone = currentZoneFrame();
      const baseOpacity = currentBaseOpacity();
      const border = borders.find((item) => item.id === sideState.borderId) || borders[0];
      const topRingRadius = clamp(Number(sideState.topRingRadius ?? sideState.ringRadius) || 25, 20, 34);
      const bottomRingRadius = clamp(Number(sideState.bottomRingRadius ?? sideState.ringRadius) || 25, 20, 34);
      const artworkSize = clamp(Number(sideState.artworkSize) || ARTWORK_DEFAULT_SIZE, ARTWORK_MIN_SIZE, ARTWORK_MAX_SIZE);
      const artworkX = clamp(Number(sideState.artworkX) || 50, 6, 94);
      const artworkY = clamp(Number(sideState.artworkY) || 50, 6, 94);
      const artworkRotation = clamp(Number(sideState.artworkRotation) || 0, -180, 180);
      const previewId = slugify(sideName);
      return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
          ${baseImageUrl ? `<image href="${escapeXml(baseImageUrl)}" width="1000" height="1000" preserveAspectRatio="xMidYMid slice" />` : '<rect width="1000" height="1000" fill="#ffffff" />'}
          <svg x="${escapeXml(zone.left)}" y="${escapeXml(zone.top)}" width="${escapeXml(zone.width)}" height="${escapeXml(zone.height)}" viewBox="0 0 100 100">
            <defs>
              <path id="token-top-${previewId}" d="${circlePathTop(topRingRadius)}" />
              <path id="token-bottom-${previewId}" d="${circlePathBottom(bottomRingRadius)}" />
            </defs>
            <circle cx="50" cy="50" r="41" fill="rgba(255,250,243,${baseOpacity})" stroke="rgba(23,17,11,0.08)" stroke-width="1.2" />
            <image href="${escapeXml(border.src || '')}" x="8" y="8" width="84" height="84" preserveAspectRatio="xMidYMid meet" />
            ${sideState.artworkUrl ? `
              <image
                href="${escapeXml(sideState.artworkUrl)}"
                x="${artworkX - (artworkSize / 2)}"
                y="${artworkY - (artworkSize / 2)}"
                width="${artworkSize}"
                height="${artworkSize}"
                preserveAspectRatio="xMidYMid meet"
                transform="rotate(${artworkRotation} ${artworkX} ${artworkY})"
              />
            ` : ''}
            ${renderFreeformLayers(sideState, { interactive: false })}
            ${sideState.centerText ? `<text x="50" y="54" text-anchor="middle" font-family="${escapeXml(FONT_MAP[sideState.font] || FONT_MAP['Roman Serif'])}" font-size="${clamp(sideState.centerSize, 7, 18)}" font-weight="${sideState.textBold || sideState.font === 'Bold Block' ? '800' : '700'}" font-style="${sideState.textItalic ? 'italic' : 'normal'}" text-decoration="${sideState.textUnderline ? 'underline' : 'none'}" letter-spacing="0.06em" fill="#17110b">${escapeXml(sideState.centerText)}</text>` : ''}
            ${sideState.outerTop ? `<text font-family="${escapeXml(FONT_MAP[sideState.font] || FONT_MAP['Roman Serif'])}" font-size="${clamp(sideState.ringSize, 4, 10)}" font-weight="${sideState.textBold || sideState.font === 'Bold Block' ? '800' : '700'}" font-style="${sideState.textItalic ? 'italic' : 'normal'}" text-decoration="${sideState.textUnderline ? 'underline' : 'none'}" letter-spacing="0.16em" fill="#17110b" text-transform="uppercase"><textPath href="#token-top-${previewId}" startOffset="0%" text-anchor="middle">${escapeXml(sideState.outerTop)}</textPath></text>` : ''}
            ${sideState.outerBottom ? `<text font-family="${escapeXml(FONT_MAP[sideState.font] || FONT_MAP['Roman Serif'])}" font-size="${clamp(sideState.ringSize, 4, 10)}" font-weight="${sideState.textBold || sideState.font === 'Bold Block' ? '800' : '700'}" font-style="${sideState.textItalic ? 'italic' : 'normal'}" text-decoration="${sideState.textUnderline ? 'underline' : 'none'}" letter-spacing="0.16em" fill="#17110b" text-transform="uppercase"><textPath href="#token-bottom-${previewId}" startOffset="0%" text-anchor="middle">${escapeXml(sideState.outerBottom)}</textPath></text>` : ''}
          </svg>
        </svg>
      `;
    };

    const buildTokenPreview = (sideName, sideState, baseImageUrl) => {
      const svg = buildTokenPreviewSvg(sideName, sideState, baseImageUrl);
      const preview = encodeSvg(svg);
      return preview.length <= 120000 ? preview : '';
    };

    const inlineUrlAsDataUrl = async (url) => {
      const source = String(url || '').trim();
      if (!source || source.startsWith('data:')) return source;
      try {
        const response = await fetch(source, { credentials: 'omit', mode: 'cors' });
        if (!response.ok) return source;
        const blob = await response.blob();
        return await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : source);
          reader.onerror = () => reject(reader.error || new Error('Unable to inline artwork.'));
          reader.readAsDataURL(blob);
        });
      } catch (_) {
        return source;
      }
    };

    const exportableSideState = async (sideState) => Object.assign({}, sideState, {
      artworkUrl: await inlineUrlAsDataUrl(sideState.artworkUrl || ''),
      freeformLayers: getSideLayers(sideState),
    });

    const buildProductionSheetSvg = async (bundle) => {
      const exportFront = await exportableSideState(state.front);
      const exportBack = await exportableSideState(state.back);
      const frontPreview = encodeSvg(buildTokenPreviewSvg('front-production', exportFront, ''));
      const hasBack = bundle.hasBack;
      const backPreview = hasBack ? encodeSvg(buildTokenPreviewSvg('back-production', exportBack, '')) : '';
      const headline = `${root.dataset.productTitle || 'Custom token order'} production sheet`;
      const detail = `${bundle.tokenQuantity} tokens · ${hasBack ? 'front and back' : 'front only'} · ${tokenOptionSummary()}`;
      const namesLine = state.namesList.trim() ? `<text x="90" y="132" font-family="Arial, sans-serif" font-size="26" fill="#5b544b">${escapeXml(state.namesList.trim())}</text>` : '';
      const notesLine = state.notes ? `<text x="90" y="${state.namesList.trim() ? 166 : 132}" font-family="Arial, sans-serif" font-size="24" fill="#5b544b">${escapeXml(state.notes)}</text>` : '';
      return `
        <svg xmlns="http://www.w3.org/2000/svg" width="2400" height="1300" viewBox="0 0 2400 1300">
          <rect width="2400" height="1300" fill="#ffffff" />
          <text x="90" y="74" font-family="Arial, sans-serif" font-size="42" font-weight="700" fill="#17110b">${escapeXml(headline)}</text>
          <text x="90" y="110" font-family="Arial, sans-serif" font-size="28" fill="#5b544b">${escapeXml(detail)}</text>
          ${namesLine}
          ${notesLine}
          <text x="500" y="225" font-family="Arial, sans-serif" font-size="26" font-weight="700" text-anchor="middle" fill="#17110b">Front</text>
          <image href="${frontPreview}" x="60" y="250" width="880" height="880" preserveAspectRatio="xMidYMid meet" />
          ${hasBack ? `<text x="1900" y="225" font-family="Arial, sans-serif" font-size="26" font-weight="700" text-anchor="middle" fill="#17110b">Back</text>` : ''}
          ${hasBack ? `<image href="${backPreview}" x="1460" y="250" width="880" height="880" preserveAspectRatio="xMidYMid meet" />` : ''}
        </svg>
      `;
    };

    const svgMarkupToPngDataUrl = async (svgMarkup, width, height) => {
      const safeWidth = Math.max(600, Math.round(Number(width) || 2400));
      const safeHeight = Math.max(600, Math.round(Number(height) || 1300));
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.decoding = 'async';
      const imageUrl = encodeSvg(svgMarkup);
      await new Promise((resolve, reject) => {
        image.onload = resolve;
        image.onerror = () => reject(new Error('Unable to render production preview.'));
        image.src = imageUrl;
      });
      const canvas = document.createElement('canvas');
      canvas.width = safeWidth;
      canvas.height = safeHeight;
      const context = canvas.getContext('2d');
      if (!context) {
        throw new Error('Unable to create production canvas.');
      }
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, safeWidth, safeHeight);
      context.drawImage(image, 0, 0, safeWidth, safeHeight);
      return canvas.toDataURL('image/png');
    };

    const saveTokenProductionSession = async (bundle) => {
      const formVariantId = productForm?.querySelector('[name="id"]')?.value || '';
      const sessionCreated = await requestJson('/api/customizer/session', {
        method: 'POST',
        body: JSON.stringify({
          browser_key: browserKey,
          shop_domain: window.location.hostname,
          storefront_url: window.location.origin,
          variant_id: formVariantId,
          product_title: root.dataset.productTitle || '',
          product_handle: root.dataset.productHandle || '',
          product_image_url: frontImage || '',
          return_to: window.location.href,
          canvas_width: 2400,
          canvas_height: 1300,
          boundary: currentZoneFrame(),
        }),
      });
      const session = sessionCreated.session || {};
      const productionSvg = await buildProductionSheetSvg(bundle);
      let previewDataUrl = '';
      try {
        previewDataUrl = await svgMarkupToPngDataUrl(productionSvg, 2400, 1300);
      } catch (error) {
        console.warn('Token production PNG render failed; saving SVG package only.', error);
      }
      const payload = {
        browser_key: browserKey,
        design_json: {
          mode: 'lbec-token-customizer',
          front: JSON.parse(serializeSideLayout(state.front)),
          back: JSON.parse(serializeSideLayout(state.back)),
          pricing: {
            tier: bundle.tier,
            total_cents: bundle.total,
            savings_cents: bundle.savings,
          },
        },
        summary: {
          product_title: root.dataset.productTitle || '',
          quantity: bundle.tokenQuantity,
          sides: bundle.hasBack ? 'front_and_back' : 'front_only',
          options: tokenOptionSummary(),
          names: state.namesList.trim(),
          notes: state.notes || '',
        },
        preview_data_url: previewDataUrl,
        svg_data: productionSvg,
        finalize: false,
      };
      const saved = await requestJson(`/api/customizer/session/${encodeURIComponent(session.token || '')}/save`, {
        method: 'POST',
        body: JSON.stringify(payload),
      });
      return saved.session || session;
    };

    const buildTokenBundle = () => {
      const tokenQuantity = readCartQuantity(productForm);
      const dozenQuantity = Math.ceil(tokenQuantity / 12);
      const tier = tokenTierForQuantity(tokenQuantity);
      const groupId = `token-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
      const hasBack = sideHasDesign(state.back);
      const commonProperties = {
        '_LBEC Token Group': groupId,
        '_LBEC Token Quantity': String(tokenQuantity),
        '_LBEC Token Dozens': String(dozenQuantity),
        '_LBEC Token Tier': tier,
        '_LBEC Token Front': buildSideSummary('Front', state.front),
        '_LBEC Token Back': buildSideSummary('Back', state.back),
        '_LBEC Token Front Layout': serializeSideLayout(state.front),
        '_LBEC Token Back Layout': serializeSideLayout(state.back),
        '_LBEC Token Front Artwork URL': state.front.artworkUrl || '',
        '_LBEC Token Back Artwork URL': state.back.artworkUrl || '',
        '_LBEC Token Options': tokenOptionSummary(),
        '_LBEC Token Front Freeform': JSON.stringify(getSideLayers(state.front)),
        '_LBEC Token Back Freeform': JSON.stringify(getSideLayers(state.back)),
      };
      if (state.namesList.trim()) {
        commonProperties['_LBEC Token Names'] = state.namesList.trim();
      }
      const frontPreview = buildTokenPreview('front', state.front, frontImage);
      const backPreview = buildTokenPreview('back', state.back, backImage || frontImage);
      if (frontPreview) commonProperties['_LBEC Token Front Preview'] = frontPreview;
      if (backPreview) commonProperties['_LBEC Token Back Preview'] = backPreview;
      const visibleAnchorProperties = {
        'Token quantity': `${tokenQuantity} tokens`,
        'Engraving sides': hasBack ? 'Front and back' : 'Front only',
        'Token options': tokenOptionSummary(),
        'Artwork proof requested': proofCheckbox?.checked ? 'Yes' : 'No',
      };
      if (state.namesList.trim()) {
        visibleAnchorProperties['Names/numbers'] = state.namesList.trim();
      }
      if (state.notes) visibleAnchorProperties['Production notes'] = state.notes;

      const items = [];
      const lines = [];
      let total = 0;
      let baseTotal = 0;

      const addLine = ({ id, quantity, label, cents, component, properties = {} }) => {
        if (!id || !quantity) return;
        items.push({
          id,
          quantity,
          properties: Object.assign({}, commonProperties, properties, {
            '_LBEC Token Component': component,
            '_LBEC Token Component Label': label,
          }),
        });
        lines.push({ label, quantity, cents });
        total += quantity * cents;
      };

      const addBaseComparison = (quantity, cents) => {
        if (!quantity || !cents) return;
        baseTotal += quantity * cents;
      };

      addLine({
        id: pricingComponents.anchor,
        quantity: 1,
        label: 'Physical token order anchor',
        cents: 0,
        component: 'anchor',
        properties: visibleAnchorProperties,
      });
      if (tokenQuantity < 1000) {
        addLine({
          id: pricingComponents.productionSetup,
          quantity: 1,
          label: 'Production setup',
          cents: componentPriceCents(pricingComponents.productionSetup, TOKEN_COMPONENT_PRICES.productionSetup),
          component: 'production_setup',
        });
        addBaseComparison(
          1,
          componentPriceCents(pricingComponents.productionSetup, TOKEN_COMPONENT_PRICES.productionSetup),
        );
      }
      addLine({
        id: pricingComponents.base?.[tier],
        quantity: dozenQuantity,
        label: `Base tokens ${tier}`,
        cents: componentPriceCents(pricingComponents.base?.[tier], TOKEN_COMPONENT_PRICES.base[tier]),
        component: 'base',
      });
      addBaseComparison(
        dozenQuantity,
        componentPriceCents(pricingComponents.base?.['25-99'], TOKEN_COMPONENT_PRICES.base['25-99']),
      );
      if (hasBack) {
        addLine({
          id: pricingComponents.secondSide?.[tier],
          quantity: dozenQuantity,
          label: `Second side ${tier}`,
          cents: componentPriceCents(pricingComponents.secondSide?.[tier], TOKEN_COMPONENT_PRICES.secondSide[tier]),
          component: 'second_side',
        });
        addBaseComparison(
          dozenQuantity,
          componentPriceCents(pricingComponents.secondSide?.['25-99'], TOKEN_COMPONENT_PRICES.secondSide['25-99']),
        );
      }
      if (state.names) {
        addLine({
          id: pricingComponents.names,
          quantity: dozenQuantity,
          label: 'Individual names',
          cents: componentPriceCents(pricingComponents.names, TOKEN_COMPONENT_PRICES.names),
          component: 'names',
        });
        addBaseComparison(
          dozenQuantity,
          componentPriceCents(pricingComponents.names, TOKEN_COMPONENT_PRICES.names),
        );
      }
      if (state.packaging !== 'none') {
        addLine({
          id: pricingComponents.packaging?.[state.packaging],
          quantity: dozenQuantity,
          label: PACKAGING_LABELS[state.packaging] || `${state.packaging} packaging`,
          cents: componentPriceCents(
            pricingComponents.packaging?.[state.packaging],
            TOKEN_COMPONENT_PRICES.packaging[state.packaging],
          ),
          component: 'packaging',
        });
        addBaseComparison(
          dozenQuantity,
          componentPriceCents(
            pricingComponents.packaging?.[state.packaging],
            TOKEN_COMPONENT_PRICES.packaging[state.packaging],
          ),
        );
      }

      const savings = Math.max(0, baseTotal - total);
      return { items, lines, total, tokenQuantity, dozenQuantity, tier, hasBack, savings };
    };

    const applyEstimateTier = (tierKey) => {
      const presentation = TOKEN_TIER_PRESENTATION[tierKey] || TOKEN_TIER_PRESENTATION['25-99'];
      estimateTierTexts.forEach((node) => {
        node.textContent = presentation.label;
      });
      estimateBoxes.forEach((box) => {
        const previous = box.dataset.tier || 'base';
        box.classList.remove('tier-pro', 'tier-premium', 'tier-advantage', 'tier-wholesale', 'tier-animate');
        if (presentation.cls) box.classList.add(presentation.cls);
        box.dataset.tier = presentation.key;
        if (previous !== presentation.key) {
          void box.offsetWidth;
          box.classList.add('tier-animate');
          window.setTimeout(() => box.classList.remove('tier-animate'), 1200);
        }
      });
    };

    const renderHiddenInputs = () => {
      if (summaryInput) {
        summaryInput.value = `${buildSideSummary('Front', state.front)} || ${buildSideSummary('Back', state.back)} || Options: ${tokenOptionSummary()}${state.namesList.trim() ? ` || Names/numbers: ${state.namesList.trim()}` : ''}${state.notes ? ` || Notes: ${state.notes}` : ''}`;
      }
      if (frontInput) frontInput.value = buildSideSummary('Front', state.front);
      if (backInput) backInput.value = buildSideSummary('Back', state.back);
      if (artworkSourceInput) {
        artworkSourceInput.value = `Front: ${state.front.artworkSource || 'none'} | Back: ${state.back.artworkSource || 'none'}`;
      }
    };

    const getFilteredDesigns = () => {
      let filtered = [...designs];
      if (state.libraryCategory) {
        filtered = filtered.filter((design) => design.category === state.libraryCategory);
      }
      const categorySubcategories = uniqueValues(filtered.map((design) => design.subcategory));
      if (categorySubcategories.length > 1 && state.librarySubcategory) {
        filtered = filtered.filter((design) => design.subcategory === state.librarySubcategory);
      }
      return filtered;
    };

    const syncLibrarySelection = () => {
      const categoryDesigns = designs.filter((design) => design.category === state.libraryCategory);
      const subcategories = uniqueValues(categoryDesigns.map((design) => design.subcategory));
      if (subcategories.length <= 1) {
        state.librarySubcategory = '';
        return;
      }
      if (!subcategories.includes(state.librarySubcategory)) {
        state.librarySubcategory = subcategories[0];
      }
    };

    const renderBorderButtons = () => {
      if (!borderGrid) return;
      const activeBorderId = getActiveSideState().borderId;
      borderGrid.innerHTML = borders.map((border) => `
        <button
          type="button"
          class="lbec-token-customizer__chip ${activeBorderId === border.id ? 'is-active' : ''}"
          data-lbec-token-border-id="${border.id}"
        >
          <span class="lbec-token-customizer__chip-preview"><img src="${border.src}" alt=""></span>
          <span>${border.name}</span>
        </button>
      `).join('');
      borderGrid.querySelectorAll('[data-lbec-token-border-id]').forEach((button) => {
        button.addEventListener('click', () => {
          getActiveSideState().borderId = button.dataset.lbecTokenBorderId || defaultBorderId;
          render();
        });
      });
    };

    const renderLibraryFilters = () => {
      if (!libraryFilters || !categorySelect || !subcategorySelect || !subcategoryWrap) return;
      const categories = uniqueValues(designs.map((design) => design.category));
      libraryFilters.hidden = categories.length <= 1;

      if (categories.length) {
        categorySelect.innerHTML = categories.map((category) => `
          <option value="${category}" ${category === state.libraryCategory ? 'selected' : ''}>${category}</option>
        `).join('');
      }

      const categoryDesigns = designs.filter((design) => design.category === state.libraryCategory);
      const subcategories = uniqueValues(categoryDesigns.map((design) => design.subcategory));
      if (subcategories.length > 1) {
        subcategoryWrap.hidden = false;
        subcategorySelect.innerHTML = subcategories.map((subcategory) => `
          <option value="${subcategory}" ${subcategory === state.librarySubcategory ? 'selected' : ''}>${subcategory}</option>
        `).join('');
      } else {
        subcategoryWrap.hidden = true;
        subcategorySelect.innerHTML = '';
      }
    };

    const renderDesignButtons = () => {
      if (!designGrid) return;
      const activeName = getActiveSideState().artworkName;
      const activeSource = getActiveSideState().artworkSource;
      const filteredDesigns = getFilteredDesigns();
      if (!filteredDesigns.length) {
        designGrid.innerHTML = '<p class="lbec-token-customizer__empty-note">No starter designs are available yet.</p>';
        return;
      }
      designGrid.innerHTML = filteredDesigns.map((design) => `
        <button
          type="button"
          class="lbec-token-customizer__chip ${activeName === design.name && activeSource === 'design library' ? 'is-active' : ''}"
          data-lbec-token-design-id="${design.id}"
        >
          <span class="lbec-token-customizer__chip-preview"><img src="${design.src}" alt=""></span>
          <span>${design.name}</span>
        </button>
      `).join('');

      designGrid.querySelectorAll('[data-lbec-token-design-id]').forEach((button) => {
        button.addEventListener('click', () => {
          const match = filteredDesigns.find((design) => design.id === button.dataset.lbecTokenDesignId);
          if (!match) return;
          const side = getActiveSideState();
          side.artworkName = match.name;
          side.artworkUrl = match.src;
          side.artworkSource = 'design library';
          side.artworkFile = null;
          render();
        });
      });
    };

    const renderStage = () => {
      const side = getActiveSideState();
      const currentImage = state.activeSide === 'back' ? (backImage || frontImage) : frontImage;
      if (stageImage) {
        if (currentImage) {
          stageImage.src = currentImage;
          stageImage.hidden = false;
          if (stagePlaceholder) stagePlaceholder.hidden = true;
        } else {
          stageImage.hidden = true;
          stageImage.removeAttribute('src');
          if (stagePlaceholder) stagePlaceholder.hidden = false;
        }
      }

      const border = borders.find((item) => item.id === side.borderId) || borders[0];
      if (borderImage && border?.src) {
        borderImage.setAttribute('href', border.src);
        borderImage.removeAttribute('display');
      }

      const topRingRadius = clamp(Number(side.topRingRadius ?? side.ringRadius) || 25, 20, 34);
      if (topPath) {
        topPath.setAttribute('d', circlePathTop(topRingRadius));
      }
      const bottomRingRadius = clamp(Number(side.bottomRingRadius ?? side.ringRadius) || 25, 20, 34);
      if (bottomPath) {
        bottomPath.setAttribute('d', circlePathBottom(bottomRingRadius));
      }

      if (artImage) {
        if (side.artworkUrl) {
          const artworkSize = clamp(Number(side.artworkSize) || ARTWORK_DEFAULT_SIZE, ARTWORK_MIN_SIZE, ARTWORK_MAX_SIZE);
          const artworkX = clamp(Number(side.artworkX) || 50, 6, 94);
          const artworkY = clamp(Number(side.artworkY) || 50, 6, 94);
          const artworkRotation = clamp(Number(side.artworkRotation) || 0, -180, 180);
          artImage.setAttribute('href', side.artworkUrl);
          artImage.setAttribute('x', String(artworkX - (artworkSize / 2)));
          artImage.setAttribute('y', String(artworkY - (artworkSize / 2)));
          artImage.setAttribute('width', String(artworkSize));
          artImage.setAttribute('height', String(artworkSize));
          artImage.setAttribute('transform', `rotate(${artworkRotation} ${artworkX} ${artworkY})`);
          artImage.removeAttribute('display');
        } else {
          artImage.removeAttribute('href');
          artImage.removeAttribute('transform');
          artImage.setAttribute('display', 'none');
        }
      }

      if (freeformGroup) {
        freeformGroup.innerHTML = renderFreeformLayers(side, { interactive: true });
      }

      if (middleText) {
        middleText.textContent = side.centerText || '';
        middleText.style.fontFamily = FONT_MAP[side.font] || FONT_MAP['Roman Serif'];
        middleText.style.fontSize = `${clamp(side.centerSize, 7, 18)}px`;
        middleText.style.fontWeight = side.textBold || side.font === 'Bold Block' ? '800' : '700';
        middleText.style.fontStyle = side.textItalic ? 'italic' : 'normal';
        middleText.style.textDecoration = side.textUnderline ? 'underline' : 'none';
      }

      if (topText) topText.textContent = side.outerTop || '';
      if (bottomText) bottomText.textContent = side.outerBottom || '';
      if (topWrap) {
        topWrap.style.fontFamily = FONT_MAP[side.font] || FONT_MAP['Roman Serif'];
        topWrap.style.fontSize = `${clamp(side.ringSize, 4, 10)}px`;
        topWrap.style.fontWeight = side.textBold || side.font === 'Bold Block' ? '800' : '700';
        topWrap.style.fontStyle = side.textItalic ? 'italic' : 'normal';
        topWrap.style.textDecoration = side.textUnderline ? 'underline' : 'none';
      }
      if (bottomWrap) {
        bottomWrap.style.fontFamily = FONT_MAP[side.font] || FONT_MAP['Roman Serif'];
        bottomWrap.style.fontSize = `${clamp(side.ringSize, 4, 10)}px`;
        bottomWrap.style.fontWeight = side.textBold || side.font === 'Bold Block' ? '800' : '700';
        bottomWrap.style.fontStyle = side.textItalic ? 'italic' : 'normal';
        bottomWrap.style.textDecoration = side.textUnderline ? 'underline' : 'none';
      }

      const activeSideLabel = state.activeSide === 'back' ? 'Back' : 'Front';
      if (sideFolder) {
        sideFolder.classList.toggle('is-back', state.activeSide === 'back');
        sideFolder.dataset.activeSide = state.activeSide;
      }
      if (sideFolderLabel) sideFolderLabel.textContent = `${activeSideLabel} design`;
      if (summarySide) summarySide.textContent = `Editing ${state.activeSide}`;
      if (summaryBorder) summaryBorder.textContent = `Border: ${border?.name || 'None'}`;
      if (summaryArt) {
        const extras = summarizeFreeformLayers(side);
        if (side.artworkName && extras) {
          summaryArt.textContent = `Centerpiece: ${side.artworkName} + ${extras}`;
        } else if (side.artworkName) {
          summaryArt.textContent = `Centerpiece: ${side.artworkName}`;
        } else if (extras) {
          summaryArt.textContent = extras;
        } else {
          summaryArt.textContent = 'No centerpiece selected';
        }
      }

      if (fileName) {
        fileName.hidden = !side.artworkName;
        if (side.artworkName) {
          const thumb = side.artworkUrl
            ? `<span class="lbec-token-customizer__file-thumb"><img src="${escapeXml(side.artworkUrl)}" alt=""></span>`
            : '<span class="lbec-token-customizer__file-thumb" aria-hidden="true"></span>';
          fileName.innerHTML = `
            ${thumb}
            <span>
              <strong>${escapeXml(state.activeSide === 'front' ? 'Front artwork' : 'Back artwork')}</strong>
              <small>${escapeXml(side.artworkName)}${side.artworkSource ? ` (${escapeXml(side.artworkSource)})` : ''}</small>
            </span>
          `;
        } else {
          fileName.innerHTML = '';
        }
      }

      if (clearArtButton) {
        clearArtButton.hidden = !side.artworkName && !side.artworkUrl;
      }

      sideButtons.forEach((button) => {
        const isActive = button.dataset.lbecTokenSide === state.activeSide;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', String(isActive));
      });
    };

    const renderControls = () => {
      const side = getActiveSideState();
      if (centerInput) centerInput.value = side.centerText;
      if (topInput) topInput.value = side.outerTop;
      if (bottomInput) bottomInput.value = side.outerBottom;
      populateFontSelect(fontSelect, side.font);
      if (centerSizeValue) centerSizeValue.textContent = String(side.centerSize);
      if (ringSizeValue) ringSizeValue.textContent = String(side.ringSize);
      if (topRingRadiusInput) topRingRadiusInput.value = String(side.topRingRadius ?? side.ringRadius ?? 25);
      if (bottomRingRadiusInput) bottomRingRadiusInput.value = String(side.bottomRingRadius ?? side.ringRadius ?? 25);
      if (artSizeInput) artSizeInput.value = String(side.artworkSize ?? ARTWORK_DEFAULT_SIZE);
      if (artXInput) artXInput.value = String(side.artworkX ?? 50);
      if (artYInput) artYInput.value = String(side.artworkY ?? 50);
      if (artRotationInput) artRotationInput.value = String(side.artworkRotation ?? 0);
      if (notesInput) notesInput.value = state.notes;
      if (packagingSelect) packagingSelect.value = state.packaging;
      if (namesToggle) namesToggle.checked = state.names;
      if (namesPanel) namesPanel.hidden = !state.names;
      if (namesInput) namesInput.value = state.namesList;
      if (uploadInput) uploadInput.value = '';
      renderWorkflow();
      syncTextFormatButtons();
      renderBorderButtons();
      renderLibraryFilters();
      renderDesignButtons();
      renderFreeformControls();
    };

    const renderEstimate = () => {
      const bundle = buildTokenBundle();
      if (quantityInput && String(quantityInput.value) !== String(bundle.tokenQuantity)) {
        quantityInput.value = String(bundle.tokenQuantity);
      }
      applyEstimateTier(bundle.tier);
      estimateNodes.forEach((node) => {
        node.textContent = formatMoney(bundle.total);
      });
      estimateDetails.forEach((detail) => {
        const sides = bundle.hasBack ? 'front/back' : 'front only';
        detail.textContent = `${bundle.tokenQuantity} tokens, ${sides}. ${nextTierCopy(bundle.tokenQuantity, bundle.hasBack)}`;
      });
      estimateSavingsNodes.forEach((node) => {
        node.textContent = bundle.savings > 0 ? `Save ${formatMoney(bundle.savings)} over base pricing` : '';
      });
    };

    const render = () => {
      syncLibrarySelection();
      renderControls();
      renderStage();
      renderHiddenInputs();
      renderEstimate();
      saveState();
    };

    const nudgeSelectedLayer = (action) => {
      const activeLayer = selectedLayer();
      if (!activeLayer) return;
      if (action === 'smaller') {
        updateSelectedLayerField('size', Number(activeLayer.size) - 1);
      } else if (action === 'larger') {
        updateSelectedLayerField('size', Number(activeLayer.size) + 1);
      } else if (action === 'rotate-left') {
        updateSelectedLayerField('rotation', Number(activeLayer.rotation) - 15);
      } else if (action === 'rotate-right') {
        updateSelectedLayerField('rotation', Number(activeLayer.rotation) + 15);
      } else if (action === 'move-left') {
        updateSelectedLayerField('x', Number(activeLayer.x) - 2);
      } else if (action === 'move-right') {
        updateSelectedLayerField('x', Number(activeLayer.x) + 2);
      } else if (action === 'move-up') {
        updateSelectedLayerField('y', Number(activeLayer.y) - 2);
      } else if (action === 'move-down') {
        updateSelectedLayerField('y', Number(activeLayer.y) + 2);
      } else if (action === 'center') {
        updateSelectedLayerField('x', 50, { preserveEditor: true });
        updateSelectedLayerField('y', 50);
      }
    };

    const toggleSelectedLayerFormat = (format) => {
      const activeLayer = selectedLayer();
      if (!activeLayer || !['bold', 'italic', 'underline'].includes(format)) return;
      updateSelectedLayerField(format, !activeLayer[format]);
    };

    const syncQuantityRules = () => {
      if (!quantityInput) return;
      quantityInput.min = String(TOKEN_MIN_QUANTITY);
      quantityInput.step = String(TOKEN_QUANTITY_STEP);
      quantityInput.dataset.min = String(TOKEN_MIN_QUANTITY);
      if (Number(quantityInput.value || 0) < TOKEN_MIN_QUANTITY) {
        quantityInput.value = String(TOKEN_MIN_QUANTITY);
      }
    };

    if (toggle) {
      toggle.addEventListener('click', () => {
        setPanelState(panel.hidden);
      });
    }

    sideButtons.forEach((button) => {
      button.addEventListener('click', () => {
        state.activeSide = button.dataset.lbecTokenSide === 'back' ? 'back' : 'front';
        ensureSelectedLayer();
        render();
      });
    });

    workflowButtons.forEach((button) => {
      button.addEventListener('click', () => {
        state.workflowMode = button.dataset.lbecTokenWorkflowButton === 'scratch' ? 'scratch' : 'upload';
        render();
      });
    });

    if (categorySelect) {
      categorySelect.addEventListener('change', () => {
        state.libraryCategory = categorySelect.value;
        state.librarySubcategory = '';
        render();
      });
    }

    if (subcategorySelect) {
      subcategorySelect.addEventListener('change', () => {
        state.librarySubcategory = subcategorySelect.value;
        render();
      });
    }

    if (centerInput) {
      centerInput.addEventListener('input', () => {
        getActiveSideState().centerText = centerInput.value;
        render();
      });
    }

    if (topInput) {
      topInput.addEventListener('input', () => {
        getActiveSideState().outerTop = topInput.value.toUpperCase();
        render();
      });
    }

    if (bottomInput) {
      bottomInput.addEventListener('input', () => {
        getActiveSideState().outerBottom = bottomInput.value.toUpperCase();
        render();
      });
    }

    if (fontSelect) {
      fontSelect.addEventListener('change', () => {
        getActiveSideState().font = fontSelect.value;
        render();
      });
    }

    textFormatButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const side = getActiveSideState();
        const format = button.dataset.lbecTokenTextFormat;
        if (format === 'bold') side.textBold = !side.textBold;
        if (format === 'italic') side.textItalic = !side.textItalic;
        if (format === 'underline') side.textUnderline = !side.textUnderline;
        render();
      });
    });

    textActionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const side = getActiveSideState();
        const action = button.dataset.lbecTokenTextAction;
        if (action === 'center-smaller') side.centerSize = clamp(Number(side.centerSize) - 0.5, 7, 18);
        if (action === 'center-larger') side.centerSize = clamp(Number(side.centerSize) + 0.5, 7, 18);
        if (action === 'ring-smaller') side.ringSize = clamp(Number(side.ringSize) - 0.5, 4, 10);
        if (action === 'ring-larger') side.ringSize = clamp(Number(side.ringSize) + 0.5, 4, 10);
        render();
      });
    });

    if (topRingRadiusInput) {
      topRingRadiusInput.addEventListener('input', () => {
        getActiveSideState().topRingRadius = Number(topRingRadiusInput.value);
        render();
      });
    }

    if (bottomRingRadiusInput) {
      bottomRingRadiusInput.addEventListener('input', () => {
        getActiveSideState().bottomRingRadius = Number(bottomRingRadiusInput.value);
        render();
      });
    }

    if (artSizeInput) {
      artSizeInput.addEventListener('input', () => {
        updateArtworkField('artworkSize', artSizeInput.value);
      });
    }

    if (artXInput) {
      artXInput.addEventListener('input', () => {
        updateArtworkField('artworkX', artXInput.value);
      });
    }

    if (artYInput) {
      artYInput.addEventListener('input', () => {
        updateArtworkField('artworkY', artYInput.value);
      });
    }

    if (artRotationInput) {
      artRotationInput.addEventListener('input', () => {
        updateArtworkField('artworkRotation', artRotationInput.value);
      });
    }

    artActionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const side = getActiveSideState();
        const action = button.dataset.lbecTokenArtAction;
        if (action === 'smaller') side.artworkSize = clamp(Number(side.artworkSize) - 3, ARTWORK_MIN_SIZE, ARTWORK_MAX_SIZE);
        if (action === 'larger') side.artworkSize = clamp(Number(side.artworkSize) + 3, ARTWORK_MIN_SIZE, ARTWORK_MAX_SIZE);
        if (action === 'rotate-left') side.artworkRotation = clamp(Number(side.artworkRotation) - 15, -180, 180);
        if (action === 'rotate-right') side.artworkRotation = clamp(Number(side.artworkRotation) + 15, -180, 180);
        if (action === 'center') {
          side.artworkX = 50;
          side.artworkY = 50;
        }
        render();
      });
    });

    if (addFreeformTextButton) {
      addFreeformTextButton.addEventListener('click', () => {
        const side = getActiveSideState();
        if (getSideLayers(side).length >= MAX_TOKEN_FREEFORM_LAYERS) return;
        const layer = makeFreeformTextLayer();
        side.freeformLayers = [...getSideLayers(side), layer];
        state.selectedLayerId = layer.id;
        render();
      });
    }

    if (addFreeformIconButton) {
      addFreeformIconButton.addEventListener('click', () => {
        const side = getActiveSideState();
        if (getSideLayers(side).length >= MAX_TOKEN_FREEFORM_LAYERS) return;
        const layer = makeFreeformIconLayer();
        side.freeformLayers = [...getSideLayers(side), layer];
        state.selectedLayerId = layer.id;
        render();
      });
    }

    if (freeformList) {
      freeformList.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const selectButton = event.target.closest('[data-lbec-token-select-layer]');
        if (selectButton) {
          setSelectedLayerId(selectButton.dataset.lbecTokenSelectLayer || '');
          return;
        }
        const deleteButton = event.target.closest('[data-lbec-token-delete-layer]');
        if (deleteButton) {
          const side = getActiveSideState();
          const targetId = deleteButton.dataset.lbecTokenDeleteLayer || '';
          side.freeformLayers = getSideLayers(side).filter((layer) => layer.id !== targetId);
          if (state.selectedLayerId === targetId) {
            state.selectedLayerId = side.freeformLayers[0]?.id || '';
          }
          render();
        }
      });
    }

    if (freeformEditor) {
      const handleLayerFieldChange = (event) => {
        if (!(event.target instanceof Element)) return;
        const fieldTarget = event.target.closest('[data-lbec-token-layer-field]');
        if (!fieldTarget) return;
        const field = fieldTarget.dataset.lbecTokenLayerField;
        if (!field) return;
        updateSelectedLayerField(field, fieldTarget.value, { preserveEditor: true });
      };
      freeformEditor.addEventListener('input', handleLayerFieldChange);
      freeformEditor.addEventListener('change', handleLayerFieldChange);
      freeformEditor.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const actionButton = event.target.closest('[data-lbec-token-layer-action]');
        if (actionButton) {
          nudgeSelectedLayer(actionButton.dataset.lbecTokenLayerAction || '');
          return;
        }
        const toggleButton = event.target.closest('[data-lbec-token-layer-toggle]');
        if (toggleButton) {
          toggleSelectedLayerFormat(toggleButton.dataset.lbecTokenLayerToggle || '');
        }
      });
    }

    if (stageOverlay) {
      stageOverlay.addEventListener('pointerdown', (event) => {
        if (!(event.target instanceof Element)) return;
        const artworkTarget = event.target.closest('[data-lbec-token-artwork-image]');
        if (artworkTarget && getActiveSideState().artworkUrl) {
          event.preventDefault();
          const side = getActiveSideState();
          const point = pointerToStagePoint(event);
          dragState = {
            pointerId: event.pointerId,
            kind: 'artwork',
            offsetX: side.artworkX - point.x,
            offsetY: side.artworkY - point.y,
          };
          stageOverlay.setPointerCapture?.(event.pointerId);
          return;
        }
        const layerTarget = event.target.closest('[data-lbec-token-layer-id]');
        if (!layerTarget) return;
        const layerId = layerTarget.getAttribute('data-lbec-token-layer-id') || '';
        const layer = getSideLayers(getActiveSideState()).find((item) => item.id === layerId);
        if (!layer) return;
        event.preventDefault();
        const point = pointerToStagePoint(event);
        setSelectedLayerId(layerId, { preserveEditor: true });
        dragState = {
          pointerId: event.pointerId,
          kind: 'freeform',
          layerId,
          offsetX: layer.x - point.x,
          offsetY: layer.y - point.y,
        };
        stageOverlay.setPointerCapture?.(event.pointerId);
      });

      stageOverlay.addEventListener('pointermove', (event) => {
        if (!dragState || dragState.pointerId !== event.pointerId) return;
        if (dragState.kind === 'artwork') {
          const side = getActiveSideState();
          const point = pointerToStagePoint(event);
          side.artworkX = clamp(point.x + dragState.offsetX, 6, 94);
          side.artworkY = clamp(point.y + dragState.offsetY, 6, 94);
          renderStage();
          renderHiddenInputs();
          renderEstimate();
          saveState();
          return;
        }
        const side = getActiveSideState();
        const index = getSideLayers(side).findIndex((layer) => layer.id === dragState.layerId);
        if (index === -1) return;
        const point = pointerToStagePoint(event);
        const next = Object.assign({}, getSideLayers(side)[index], {
          x: clamp(point.x + dragState.offsetX, 6, 94),
          y: clamp(point.y + dragState.offsetY, 6, 94),
        });
        side.freeformLayers[index] = normalizeFreeformLayer(next);
        renderFreeformList();
        renderStage();
        renderHiddenInputs();
        renderEstimate();
        saveState();
      });

      const releaseDrag = (event) => {
        if (!dragState || dragState.pointerId !== event.pointerId) return;
        stageOverlay.releasePointerCapture?.(event.pointerId);
        dragState = null;
      };

      stageOverlay.addEventListener('pointerup', releaseDrag);
      stageOverlay.addEventListener('pointercancel', releaseDrag);
      stageOverlay.addEventListener('lostpointercapture', () => {
        dragState = null;
      });
    }

    if (notesInput) {
      notesInput.addEventListener('input', () => {
        state.notes = notesInput.value;
        renderHiddenInputs();
        saveState();
      });
    }

    if (uploadInput) {
      uploadInput.addEventListener('change', () => {
        const file = uploadInput.files && uploadInput.files[0];
        if (!file) return;
        const side = getActiveSideState();
        side.artworkName = file.name;
        side.artworkSource = 'uploaded artwork';
        side.artworkFile = file;
        if (!(file.type.startsWith('image/') || PREVIEWABLE_PATTERN.test(file.name))) {
          side.artworkUrl = '';
          render();
          return;
        }
        const reader = new FileReader();
        reader.onload = () => {
          side.artworkUrl = typeof reader.result === 'string' ? reader.result : '';
          render();
        };
        reader.readAsDataURL(file);
      });
    }

    if (clearArtButton) {
      clearArtButton.addEventListener('click', () => {
        const side = getActiveSideState();
        side.artworkName = '';
        side.artworkUrl = '';
        side.artworkSource = '';
        side.artworkFile = null;
        if (uploadInput) uploadInput.value = '';
        render();
      });
    }

    if (packagingSelect) {
      packagingSelect.addEventListener('change', () => {
        state.packaging = packagingSelect.value;
        render();
      });
    }

    if (namesToggle) {
      namesToggle.addEventListener('change', () => {
        state.names = namesToggle.checked;
        render();
      });
    }

    if (namesInput) {
      namesInput.addEventListener('input', () => {
        state.namesList = namesInput.value;
        renderHiddenInputs();
        renderEstimate();
        saveState();
      });
    }

    if (quantityInput) {
      syncQuantityRules();
      quantityInput.addEventListener('change', renderEstimate);
      quantityInput.addEventListener('input', renderEstimate);
      quantityInput.addEventListener('blur', () => {
        const normalized = normalizeTokenQuantity(quantityInput.value);
        if (Number(quantityInput.value) !== normalized) {
          quantityInput.value = String(normalized);
        }
        renderEstimate();
      });
    }

    const setTokenFormLoading = (loading) => {
      const formId = productForm?.getAttribute('id');
      const button = productFormShell?.querySelector('[type="submit"]')
        || (formId ? document.querySelector(`[type="submit"][form="${CSS.escape(formId)}"]`) : null);
      const spinner = button?.querySelector('.loading__spinner') || productFormShell?.querySelector('.loading__spinner');
      if (!button) return;
      if (loading) {
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        spinner?.classList.remove('hidden');
      } else {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
        spinner?.classList.add('hidden');
      }
    };

    const showTokenCartError = (message) => {
      const wrapper = productFormShell?.querySelector('.product-form__error-message-wrapper');
      const text = wrapper?.querySelector('.product-form__error-message');
      if (!wrapper || !text) return;
      text.textContent = message || 'Unable to add token order to cart.';
      wrapper.removeAttribute('hidden');
    };

    const clearTokenCartError = () => {
      const wrapper = productFormShell?.querySelector('.product-form__error-message-wrapper');
      if (wrapper) wrapper.setAttribute('hidden', '');
    };

    const appendPropertiesToFormData = (formData, properties = {}) => {
      Object.entries(properties).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return;
        formData.set(`properties[${key}]`, String(value));
      });
    };

    const appendArtworkFilesToFormData = (formData) => {
      formData.delete('properties[Token Artwork Upload]');
      const appendFile = (propertyName, file) => {
        if (!file || typeof file.name !== 'string') return;
        formData.set(`properties[${propertyName}]`, file, file.name);
      };
      appendFile('Token Front Artwork File', state.front.artworkFile);
      appendFile('Token Back Artwork File', state.back.artworkFile);
    };

    const addTokenAnchorToCart = async (anchorItem, cart) => {
      if (!productForm || !anchorItem) {
        throw new Error('Token order form is not ready.');
      }

      const formData = new FormData(productForm);
      formData.set('id', String(pricingComponents.anchor));
      formData.set('quantity', '1');
      appendPropertiesToFormData(formData, anchorItem.properties);
      appendArtworkFilesToFormData(formData);

      if (cart) {
        formData.set('sections', cart.getSectionsToRender().map((section) => section.id).join(','));
        formData.set('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }

      const response = await fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
        body: formData,
      });
      const parsed = await response.json();
      if (!response.ok || parsed.status) {
        throw new Error(parsed.description || parsed.message || 'Unable to attach token artwork to the cart.');
      }
      return parsed;
    };

    const addTokenBundleToCart = async () => {
      const bundle = buildTokenBundle();
      if (!bundle.items.length || !pricingComponents.anchor) {
        throw new Error('Token pricing components are not configured.');
      }
      let productionSession = null;
      let backupMode = 'cart-properties-only';
      let backupError = '';
      try {
        productionSession = await saveTokenProductionSession(bundle);
        if (productionSession && productionSession.token) {
          backupMode = 'backend-session-and-cart-properties';
        }
      } catch (error) {
        console.warn('Token production session save failed; continuing with cart-property fallback.', error);
        backupError = error instanceof Error ? error.message : 'Unable to save production session.';
      }
      const previewUrl = productionSession?.preview_url
        ? `${window.location.origin}${productionSession.preview_url}`
        : '';
      const svgUrl = productionSession?.svg_url
        ? `${window.location.origin}${productionSession.svg_url}`
        : '';
      bundle.items.forEach((item) => {
        item.properties = Object.assign({}, item.properties, {
          '_LBEC Token Session': productionSession?.token || '',
          '_LBEC Token Production Preview': previewUrl,
          '_LBEC Token Production SVG': svgUrl,
          '_LBEC Token Backup Mode': backupMode,
          '_LBEC Token Backup Error': backupError,
        });
      });

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const anchorItem = bundle.items.find((item) => String(item.id) === String(pricingComponents.anchor));
      const componentItems = bundle.items.filter((item) => String(item.id) !== String(pricingComponents.anchor));

      const anchorParsed = await addTokenAnchorToCart(anchorItem, cart);
      if (!componentItems.length) {
        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }
        cart.renderContents(anchorParsed);
        return;
      }

      const payload = { items: componentItems };
      if (cart) {
        payload.sections = cart.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
        cart.setActiveElement(document.activeElement);
      }

      const response = await fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const parsed = await response.json();
      if (!response.ok || parsed.status) {
        throw new Error(parsed.description || parsed.message || 'Unable to add token order to cart.');
      }

      if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'lbec-token-customizer',
          productVariantId: pricingComponents.anchor,
          cartData: parsed,
        });
      }
      cart.renderContents(parsed);
    };

    if (productForm) {
      productForm.addEventListener('submit', (event) => {
        if (!pricingComponents.anchor) {
          renderHiddenInputs();
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        renderHiddenInputs();
        clearTokenCartError();
        setTokenFormLoading(true);
        addTokenBundleToCart()
          .catch((error) => {
            console.error(error);
            showTokenCartError(error.message);
          })
          .finally(() => {
            setTokenFormLoading(false);
          });
      }, true);
    }

    render();
    if (toggle) {
      setPanelState(toggle.getAttribute('aria-expanded') === 'true');
    } else if (panel) {
      panel.hidden = false;
    }
  };

  const boot = () => {
    document.querySelectorAll('[data-lbec-token-customizer]').forEach((root) => {
      initTokenCustomizer(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
